import React, { useEffect, useState, useCallback } from 'react';
import api from '../services/api';
import { FiPlus, FiEdit, FiTrash, FiUsers, FiRotateCcw, FiClock } from 'react-icons/fi';
import { FiFileText, FiBookOpen, FiEdit3, FiBarChart2 } from 'react-icons/fi';
import { MdArrowUpward } from 'react-icons/md';
import Select from 'react-select';
import { DragDropContext, Droppable, Draggable } from '@hello-pangea/dnd';
import EvaluationModal from '../components/EvaluationModal';
import Modal from 'react-modal';
import Swal from 'sweetalert2';
import 'sweetalert2/dist/sweetalert2.min.css';
import OuvertureClasseModal from '../components/OuvertureClasseModal';
import BulkOuvertureModal from '../components/BulkOuvertureModal';
import ConditionalButton from '../components/common/ConditionalButton';
import { useAcademicYear } from '../contexts/AcademicYearContext';
import { useAuth } from '../contexts/AuthContext';
import { useSelectStyles } from '../utils/selectStyles';

// Fonction d'appréciation automatique pour la saisie des moyennes
function getAppreciation(note) {
  const n = parseFloat(note);
  if (isNaN(n)) return '';
  if (n >= 18) return 'Excellent';
  if (n >= 16) return 'Très bien';
  if (n >= 14) return 'Bien';
  if (n >= 12) return 'Assez bien';
  if (n >= 10) return 'Passable ou moyen';
  if (n >= 8) return 'Insuffisant';
  if (n >= 7) return 'Très insuffisant';
  if (n >= 5) return 'Faible';
  return 'Très faible';
}

// Fonction pour formater l'affichage avec virgule comme séparateur décimal
function formatValeurForDisplay(valeur) {
  if (valeur === null || valeur === undefined || valeur === '') return '';
  const str = String(valeur);
  return str.replace('.', ',');
}

const OuverturesClassesPage = () => {
  
  const [showBulletinModal, setShowBulletinModal] = useState(false);
  const [selectedBulletinClasse, setSelectedBulletinClasse] = useState(null);
  const [selectedBulletinPeriode, setSelectedBulletinPeriode] = useState(null);
  const [loadingBulletin, setLoadingBulletin] = useState(false);
  const { selectedYear } = useAcademicYear();
  const { user } = useAuth();
  const selectStyles = useSelectStyles(); // Appel du hook au niveau supérieur
  
  const [ouvertures, setOuvertures] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [editing, setEditing] = useState(null);
  const [showBulkModal, setShowBulkModal] = useState(false);

  // Pour le modal liste élèves
  const [showListModal, setShowListModal] = useState(false);
  const [listEleves, setListEleves] = useState([]);
  const [listClasse, setListClasse] = useState(null);
  // Passage classe supérieure
  const [showPromotionModal, setShowPromotionModal] = useState(false);
  const [promotionSourceOuverture, setPromotionSourceOuverture] = useState(null);
  const [promotionEleves, setPromotionEleves] = useState([]);
  const [promotionSelected, setPromotionSelected] = useState([]);
  const [promotionTargetOuverture, setPromotionTargetOuverture] = useState(null);
  const [promotionTargetClasses, setPromotionTargetClasses] = useState([]);
  const [promotionLoading, setPromotionLoading] = useState(false);
  // Hooks pour impression individuelle élève
  const [openedPeriodSelectorEleveId, setOpenedPeriodSelectorEleveId] = React.useState(null);
  const [periodSelectedByEleveId, setPeriodSelectedByEleveId] = React.useState({});
  const [loadingEleveBulletinId, setLoadingEleveBulletinId] = React.useState(null);

  // Pour le modal des moyennes
  const [showMoyennesModal, setShowMoyennesModal] = useState(false);
  const [moyennesData, setMoyennesData] = useState({eleves: [], matieres: [], moyennes: []});
  const [moyennesClasse, setMoyennesClasse] = useState(null);
  const [dispensesByInscription, setDispensesByInscription] = useState({});

  // Pour les selects
  const [classes, setClasses] = useState([]);
  const [annees, setAnnees] = useState([]);
  const [enseignements, setEnseignements] = useState([]);
  const [niveaux, setNiveaux] = useState([]);

  // Cache pour éviter les rechargements inutiles
  const [dataCache, setDataCache] = useState({
    ouverturesAll: null,
    classes: null,
    annees: null,
    enseignements: null,
    niveaux: null,
    matieres: null,
    periodes: null,
    types: null,
    cacheTime: null
  });
  const CACHE_DURATION = 5 * 60 * 1000; // 5 minutes

  // Etat de chargement
  const [isLoading, setIsLoading] = useState(true);
  const [lastUpdate, setLastUpdate] = useState(null);

  // Pour le modal d'évaluation
  const [showEvalModal, setShowEvalModal] = useState(false);
  const [evalEditing, setEvalEditing] = useState(null);
  const [evalDefaultOuvertureId, setEvalDefaultOuvertureId] = useState(null);
  const [evalMatieres, setEvalMatieres] = useState([]); // Matières filtrées pour l'évaluation dans la classe spécifique
  const [matieres, setMatieres] = useState([]);
  const [periodes, setPeriodes] = useState([]);
  const [types, setTypes] = useState([]);
  const [ouverturesAll, setOuverturesAll] = useState([]);

  // Pour le modal de saisie manuelle de moyenne (nouvelle version)
  const [showManualMoyenneModal, setShowManualMoyenneModal] = useState(false);
  const [manualMoyenneMatiere, setManualMoyenneMatiere] = useState('');
  const [manualMoyennePeriode, setManualMoyennePeriode] = useState('');
  const [manualMoyenneOuvertureId, setManualMoyenneOuvertureId] = useState(null);
  const [manualMoyenneEleves, setManualMoyenneEleves] = useState([]); // [{eleve_id, nom, prenom, valeur, appreciation}]
  const [manualMoyenneEntete, setManualMoyenneEntete] = useState({classe: '', matiere: '', annee: '', periode: ''});
  const [manualMoyenneLoaded, setManualMoyenneLoaded] = useState(false);
  // const [manualMoyenneExistantes, setManualMoyenneExistantes] = useState([]); // Temporairement commenté car non utilisé
  const manualInputsRefs = React.useRef([]);
  // Pour le modal de liaison matières
  const [showMatModal, setShowMatModal] = useState(false);
  const [matModalOuverture, setMatModalOuverture] = useState(null);
  const [matModalClasseMatieres, setMatModalClasseMatieres] = useState([]);
  const [matModalLoading, setMatModalLoading] = useState(false);
  // Pour le modal d'édition de liaison matière
  const [showEditLiaisonModal, setShowEditLiaisonModal] = useState(false);
  const [editingLiaison, setEditingLiaison] = useState(null);
  const [editLiaisonForm, setEditLiaisonForm] = useState({
    coef: '', ordre_bulletin: '', professeur_id: '', groupe_id: '', calculated: 'Y'
  });
  const [professeurs, setProfesseurs] = useState([]);
  const [qualifications, setQualifications] = useState([]);
  const [profQualif, setProfQualif] = useState([]);
  const [classeMatieres, setClasseMatieres] = useState([]);
  const [classeMatieresRefreshKey, setClasseMatieresRefreshKey] = useState(0); // Clé pour forcer le re-render
  const [showPrintMoyModal, setShowPrintMoyModal] = useState(false);
  const [printMoySelectedPeriods, setPrintMoySelectedPeriods] = useState([]);
  const [etablissement, setEtablissement] = useState(null);
  
  // Charger les données des professeurs et de l'établissement en parallèle (non bloquant)
  useEffect(() => {
    Promise.all([
      api.get('/professeurs').then(res => res.data.data || []).catch(() => []),
      api.get('/qualifications').then(res => res.data.data || []).catch(() => []),
      api.get('/prof-qualif').then(res => res.data.data || []).catch(() => []),
      api.get('/etablissement').then(res => res.data.data || null).catch(() => null)
    ]).then(([professeurs, qualifications, profQualif, etab]) => {
      setProfesseurs(professeurs);
      setQualifications(qualifications);
      setProfQualif(profQualif);
      setEtablissement(etab);
    }).catch(error => {
      console.error('Erreur lors du chargement des données professeurs/établissement:', error);
    });
  }, []);

  // Fonction utilitaire pour vérifier si le cache est valide (utilise useRef pour éviter les re-renders)
  const cacheTimeRef = React.useRef(dataCache.cacheTime);
  React.useEffect(() => {
    cacheTimeRef.current = dataCache.cacheTime;
  }, [dataCache.cacheTime]);

  const isCacheValid = useCallback(() => {
    if (!cacheTimeRef.current) return false;
    return Date.now() - cacheTimeRef.current < CACHE_DURATION;
  }, [CACHE_DURATION]);

  // Fonction pour invalider le cache
  const invalidateCache = () => {
    setDataCache({
      ouverturesAll: null,
      classes: null,
      annees: null,
      enseignements: null,
      niveaux: null,
      matieres: null,
      periodes: null,
      types: null,
      cacheTime: null
    });
    setLastUpdate(null);
    console.log('🗑️ Cache invalidé');
  };

  const fetchOuvertures = useCallback(async () => {
    try {
      let res;


      // Si l'utilisateur est un enseignant, récupérer seulement ses classes
      if (user?.role === 'enseignant' && user?.professeur_id) {
        res = await api.get(`/ouvertures-classes/professeur/${user.professeur_id}`);
      } else {
        // Pour les autres rÃ´les (admin, etc.), récupérer toutes les ouvertures
        res = await api.get('/ouvertures-classes');
      }

      setOuvertures(res.data.data || []);
    } catch (error) {
      console.error('Erreur lors du chargement des ouvertures de classes:', error);
      setOuvertures([]);
    }
  }, [user]);

  // Référence pour accéder aux données du cache sans déclencher de re-render
  const dataCacheRef = React.useRef(dataCache);
  React.useEffect(() => {
    dataCacheRef.current = dataCache;
  }, [dataCache]);

  // Fonction pour charger les données avec cache optimisé
  const loadDataWithCache = useCallback(async () => {
    setIsLoading(true);
    const now = Date.now();
    const currentCache = dataCacheRef.current;
    const currentUser = user;

    try {
      // Vérifier le cache pour les données statiques
      const cacheValid = isCacheValid();
      const useCache = cacheValid && currentCache.ouverturesAll && currentCache.classes && currentCache.annees && currentCache.enseignements && currentCache.niveaux && currentCache.matieres && currentCache.periodes && currentCache.types;
      
      if (useCache) {
        console.log('🔄 Utilisation du cache pour toutes les données statiques');
        // Charger depuis le cache
        setOuverturesAll(currentCache.ouverturesAll);
        setClasses(currentCache.classes);
        setAnnees(currentCache.annees);
        setEnseignements(currentCache.enseignements);
        setNiveaux(currentCache.niveaux);
        setMatieres(currentCache.matieres || []);
        setPeriodes(currentCache.periodes || []);
        setTypes(currentCache.types || []);
        setLastUpdate(currentCache.cacheTime);
        
        // Charger uniquement les ouvertures filtrées (dépend du rôle utilisateur)
        if (currentUser?.role === 'enseignant' && currentUser?.professeur_id) {
          const res = await api.get(`/ouvertures-classes/professeur/${currentUser.professeur_id}`);
          console.log('🔄 Cache: Ouvertures enseignant chargées:', (res.data.data || []).length);
          setOuvertures(res.data.data || []);
        } else {
          console.log('🔄 Cache: Ouvertures toutes chargées:', (currentCache.ouverturesAll || []).length);
          setOuvertures(currentCache.ouverturesAll || []);
        }
      } else {
        console.log('📥 Chargement de toutes les données depuis l\'API en parallèle');
        
        // Charger TOUTES les données en parallèle, y compris les ouvertures
        const [
          classesRes,
          anneesRes,
          enseignementsRes,
          niveauxRes,
          matieresRes,
          periodesRes,
          typesRes,
          ouverturesAllRes,
          ouverturesRes
        ] = await Promise.all([
          api.get('/classes'),
          api.get('/annees-scolaires'),
          api.get('/enseignements'),
          api.get('/niveaux'),
          api.get('/matieres'),
          api.get('/periodes'),
          api.get('/type-evaluations'),
          api.get('/ouvertures-classes'),
          // Charger les ouvertures filtrées selon le rôle
          currentUser?.role === 'enseignant' && currentUser?.professeur_id
            ? api.get(`/ouvertures-classes/professeur/${currentUser.professeur_id}`)
            : Promise.resolve({ data: { data: [] } })
        ]);

        // Mettre à jour le state en une seule fois
        setClasses(classesRes.data.data || []);
        setAnnees(anneesRes.data.data || []);
        setEnseignements(enseignementsRes.data.data || []);
        setNiveaux(niveauxRes.data.data || []);
        setMatieres(matieresRes.data.data || []);
        setPeriodes(periodesRes.data.data || []);
        setTypes(typesRes.data.data || []);
        
        // Les effectifs sont maintenant inclus directement dans la réponse de l'API
        const ouverturesAllData = ouverturesAllRes.data.data || [];
        setOuverturesAll(ouverturesAllData);
        // Pour les non-enseignants, utiliser ouverturesAllData directement
        const ouverturesToSet = currentUser?.role === 'enseignant' && currentUser?.professeur_id
          ? (ouverturesRes.data.data || [])
          : ouverturesAllData;
        console.log('📊 Ouvertures chargées:', ouverturesToSet.length);
        setOuvertures(ouverturesToSet);
        setLastUpdate(now);

        // Mettre à jour le cache avec toutes les données statiques
        setDataCache({
          ouverturesAll: ouverturesAllData,
          classes: classesRes.data.data || [],
          annees: anneesRes.data.data || [],
          enseignements: enseignementsRes.data.data || [],
          niveaux: niveauxRes.data.data || [],
          matieres: matieresRes.data.data || [],
          periodes: periodesRes.data.data || [],
          types: typesRes.data.data || [],
          cacheTime: now
        });
      }
    } catch (error) {
      console.error('❌ Erreur lors du chargement des données:', error);
      // En cas d'erreur, essayer de charger au moins les ouvertures
      try {
        if (currentUser?.role === 'enseignant' && currentUser?.professeur_id) {
          const res = await api.get(`/ouvertures-classes/professeur/${currentUser.professeur_id}`);
          setOuvertures(res.data.data || []);
        } else {
          const res = await api.get('/ouvertures-classes');
          setOuvertures(res.data.data || []);
        }
      } catch (fetchError) {
        console.error('❌ Erreur lors du chargement des ouvertures:', fetchError);
      }
    } finally {
      setIsLoading(false);
    }
  }, [isCacheValid, user]);

  // Charger les classe-matieres en parallèle avec les autres données
  useEffect(() => {
    // Charger classe-matieres de manière asynchrone sans bloquer le chargement principal
    api.get('/classe-matieres')
      .then(res => setClasseMatieres(res.data.data || []))
      .catch(error => console.error('Erreur lors du chargement des classe-matieres:', error));
  }, []);

  // Charger les données au montage et quand l'utilisateur change
  useEffect(() => {
    if (user) {
      loadDataWithCache();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user?.id, user?.role, user?.professeur_id]); // Seulement quand ces propriétés changent (loadDataWithCache est stable grâce à useRef)
    
  // Charger les matières du professeur connecté
  // Charger les matières du professeur pour une classe spécifique (pour l'évaluation)
  const loadMatieresForEvaluation = useCallback(async (ouvertureId) => {
    if (!ouvertureId) return;

    try {
      // Récupérer les matières liées à cette ouverture de classe
      const filteredClasseMatieres = classeMatieres.filter(
        cm => String(cm.ouverture_classe_id) === String(ouvertureId)
      );

      // Pour les professeurs, filtrer aussi selon leur ID
      let finalClasseMatieres = filteredClasseMatieres;
      if (user?.role === 'enseignant' && user?.professeur_id) {
        finalClasseMatieres = filteredClasseMatieres.filter(
          cm => String(cm.professeur_id) === String(user.professeur_id)
        );
      }

      // Créer la liste des matières filtrées
      const matiereIds = finalClasseMatieres.map(cm => cm.matiere_id);
      const filteredMatieres = matieres.filter(m => matiereIds.includes(m.id));

      setEvalMatieres(filteredMatieres);
    } catch (error) {
      console.error('❌ ERREUR lors du filtrage des matières pour l\'évaluation:', error);
      setEvalMatieres([]);
    }
  }, [user, classeMatieres, matieres]);

  const loadMatieresProfesseur = useCallback(async () => {
      if (user?.role === 'enseignant' && user?.professeur_id) {
        try {
          // Récupérer les matières enseignées par le professeur
          
          // Ajouter un timeout à la requête
          const controller = new AbortController();
          const timeoutId = setTimeout(() => controller.abort(), 10000); // 10 secondes
          
          let res;
          try {
            res = await api.get(`/classe-matieres?professeur_id=${user.professeur_id}`, {
              signal: controller.signal
            });
            clearTimeout(timeoutId);
            
          } catch (timeoutError) {
            clearTimeout(timeoutId);
            if (timeoutError.name === 'AbortError') {
              console.error('⏰ TIMEOUT: La requête a pris plus de 10 secondes');
              throw new Error('Timeout de la requête API');
            }
            throw timeoutError;
          }
          
          const classeMatieres = res.data.data || [];
          
          // Créer une liste des matières uniques pour le modal d'évaluation
          const matieresUniques = [];
          const matiereIds = new Set();
          
        classeMatieres.forEach(cm => {
            if (!matiereIds.has(cm.matiere_id)) {
              matiereIds.add(cm.matiere_id);
              matieresUniques.push({
                id: cm.matiere_id,
                lib_matiere: cm.lib_matiere,
                abbrev_matiere: cm.abbrev_matiere
              });
            }
          });
          
          setMatieres(matieresUniques);
        } catch (error) {
          console.error('❌ ERREUR lors du chargement des matières du professeur:', error);
          console.error('❌ Message d\'erreur:', error.message);
          console.error('❌ Status:', error.response?.status);
          console.error('❌ Data d\'erreur:', error.response?.data);
        }
      } else {
        // Pour les autres rôles, utiliser toutes les matières
      }
    }, [user]);

    useEffect(() => {
    // Charger les matières du professeur si l'utilisateur est disponible
    if (user) {
      //console.log('✅ UTILISATEUR DISPONIBLE - Chargement des matières');
      loadMatieresProfesseur();
    } else {
      //console.log('❌ UTILISATEUR NON DISPONIBLE');
    }
  }, [user, loadMatieresProfesseur]); // Retirer matieres de la dépendance car on utilise les données de l'API directement


  const handleDelete = async (id) => {
    const result = await Swal.fire({
      title: 'Supprimer cette ouverture de classe ?',
      text: 'Cette action est irréversible.',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#d33',
      cancelButtonColor: '#3085d6',
      confirmButtonText: 'Oui, supprimer',
      cancelButtonText: 'Annuler',
    });
    if (result.isConfirmed) {
      await api.delete(`/ouvertures-classes/${id}`);
      fetchOuvertures();
      Swal.fire('Supprimé !', 'L\'ouverture de classe a été supprimée.', 'success');
    }
  };

  const handleEdit = (item) => {
    setEditing(item);
    setShowModal(true);
  };

  const handleAdd = () => {
    setEditing(null);
    setShowModal(true);
  };

  const handleModalClose = () => {
    setShowModal(false);
    setEditing(null);
    fetchOuvertures();
  };

  // Ouvre le modal et charge la liste des élèves de la classe
  const handleShowList = async (ouverture) => {
    setListClasse(ouverture);
    setShowListModal(true);
    // Récupère les inscriptions de cette ouverture
    const res = await api.get(`/inscriptions?ouverture_classe_id=${ouverture.ouverture_classe_id}`);
    setListEleves(res.data.data || []);
  };

  // Supprimer une inscription (suppression en cascade de toutes les données liées)
  const handleDeleteInscription = async (inscriptionId, eleveNom, elevePrenom) => {
    const result = await Swal.fire({
      title: 'Êtes-vous sûr ?',
      text: `Voulez-vous supprimer l'inscription de ${eleveNom} ${elevePrenom} ? Cette action est irréversible. Toutes les données liées (notes, moyennes, absences, paiements, dispenses, etc.) seront également supprimées.`,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#d33',
      cancelButtonColor: '#3085d6',
      confirmButtonText: 'Oui, supprimer',
      cancelButtonText: 'Annuler'
    });

    if (result.isConfirmed) {
      try {
        await api.delete(`/inscriptions/${inscriptionId}`);
        // Recharger la liste des élèves dans la modal
        if (listClasse) {
          const res = await api.get(`/inscriptions?ouverture_classe_id=${listClasse.ouverture_classe_id}`);
          setListEleves(res.data.data || []);
        }
        // Recharger les données de la page principale pour mettre à jour les effectifs
        await loadDataWithCache();
        await Swal.fire({
          icon: 'success',
          title: 'Supprimé !',
          text: `L'inscription de ${eleveNom} ${elevePrenom} et toutes les données liées ont été supprimées avec succès.`,
          timer: 3000,
          showConfirmButton: false
        });
      } catch (error) {
        const errorMessage = error.response?.data?.message || 'Une erreur est survenue lors de la suppression de l\'inscription.';
        await Swal.fire({
          icon: 'error',
          title: 'Erreur',
          text: errorMessage,
          confirmButtonText: 'OK'
        });
      }
    }
  };

  // Imprimer la liste (ouvre le report PDF dans un nouvel onglet)
  const handlePrint = () => {
    if (listClasse) {
      const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:8000/api/v1';
      const token = localStorage.getItem('token');
      window.open(`${API_URL}/reports/liste-eleves?ouverture_classe_id=${listClasse.ouverture_classe_id}&token=${token}`, '_blank');
    }
  };

  // Exporter en CSV
  const handleExportCSV = () => {
    if (listClasse) {
      const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:8000/api/v1';
      const token = localStorage.getItem('token');
      window.location.href = `${API_URL}/reports/liste-eleves-csv?ouverture_classe_id=${listClasse.ouverture_classe_id}&token=${token}`;
    }
  };

  // Exporter en Excel
  const handleExportExcel = () => {
    if (listClasse) {
      const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:8000/api/v1';
      const token = localStorage.getItem('token');
      window.location.href = `${API_URL}/reports/liste-eleves-excel?ouverture_classe_id=${listClasse.ouverture_classe_id}&token=${token}`;
    }
  };

  useEffect(() => {
    if (showMatModal && matModalOuverture) {
      setMatModalLoading(true);
      api.get('/classe-matieres').then(res => {
        const allClasseMatieres = res.data.data || [];
        setClasseMatieres(allClasseMatieres); // Mettre à jour le state global
        setClasseMatieresRefreshKey(prev => prev + 1); // Forcer le re-render
        setMatModalClasseMatieres(
          allClasseMatieres.filter(cm => cm.ouverture_classe_id === (matModalOuverture.ouverture_classe_id || matModalOuverture.id))
        );
        setMatModalLoading(false);
      });
    }
  }, [showMatModal, matModalOuverture]);

  // Recharger les matières liées quand le modal de saisie manuelle s'ouvre
  useEffect(() => {
    if (showManualMoyenneModal && manualMoyenneOuvertureId) {
      api.get('/classe-matieres').then(res => {
        setClasseMatieres(res.data.data || []);
        setClasseMatieresRefreshKey(prev => prev + 1); // Forcer le re-render
      }).catch(error => console.error('Erreur lors du rechargement des matières:', error));
    }
  }, [showManualMoyenneModal, manualMoyenneOuvertureId]);

  const matieresLiees = matModalClasseMatieres.map(cm => cm.matiere_id);
  const matieresDisponibles = matieres.filter(m => !matieresLiees.includes(m.id));
  const matieresLieesObjs = matieres.filter(m => matieresLiees.includes(m.id));

  // Handler pour ouvrir le modal d'édition de liaison
  const handleEditLiaison = (classeMatiere) => {
    setEditingLiaison(classeMatiere);
    setEditLiaisonForm({
      coef: classeMatiere.coef || '',
      ordre_bulletin: classeMatiere.ordre_bulletin || '',
      professeur_id: classeMatiere.professeur_id || '',
      groupe_id: classeMatiere.groupe_id || classeMatiere.matiere_id || '',
      calculated: classeMatiere.calculated || 'Y',
    });
    setShowEditLiaisonModal(true);
  };

  const onMatModalDragEnd = async (result) => {
    if (!result.destination) return;
    const matiereId = parseInt(result.draggableId.replace('matiere-', ''));
    if (result.source.droppableId === 'matieres-disponibles' && result.destination.droppableId === 'matieres-liees') {
      // Lier la matière
      await api.post('/classe-matieres', {
        ouverture_classe_id: matModalOuverture.ouverture_classe_id || matModalOuverture.id,
        matiere_id: matiereId
      });
    } else if (result.source.droppableId === 'matieres-liees' && result.destination.droppableId === 'matieres-disponibles') {
      // Délier la matière
      const cm = matModalClasseMatieres.find(cm => cm.matiere_id === matiereId);
      if (cm) await api.delete(`/classe-matieres/${cm.id}`);
    }
    // Refresh
    const res = await api.get('/classe-matieres');
    const allClasseMatieres = res.data.data || [];
    setClasseMatieres(allClasseMatieres); // Mettre à jour le state global
    setClasseMatieresRefreshKey(prev => prev + 1); // Forcer le re-render des composants qui utilisent classeMatieres
    setMatModalClasseMatieres(
      allClasseMatieres.filter(cm => cm.ouverture_classe_id === (matModalOuverture.ouverture_classe_id || matModalOuverture.id))
    );
  };

  return (
    <div>
      <div className="flex justify-between items-center mb-6">
        <div>
          <h1 className="text-2xl font-semibold text-gray-900 dark:text-gray-100">Ouvertures de classes</h1>
          {user?.role === 'enseignant' && (
            <p className="text-sm text-gray-600 dark:text-gray-400 mt-1">
              Vous ne voyez que les classes où vous enseignez
            </p>
          )}
          <div className="text-xs text-gray-500 dark:text-gray-400 mt-2 flex items-center gap-4">
            {isLoading ? (
              <span className="flex items-center gap-1">
                <div className="animate-spin h-3 w-3 border border-gray-300 border-t-gray-600 rounded-full"></div>
                Chargement...
              </span>
            ) : ( 
              <>
                <span>✅ Données chargées</span>
                {lastUpdate && (
                  <span className="flex items-center">
                    <FiClock className="h-4 w-4 mr-1 text-blue-500" />
                    Dernière mise à jour: {new Date(lastUpdate).toLocaleTimeString()}
                  </span>
                )}
                {isCacheValid() && cacheTimeRef.current && (
                  <span className="text-green-600 font-medium">
                    🔄 Cache actif ({Math.max(0, Math.round((CACHE_DURATION - (Date.now() - cacheTimeRef.current)) / 1000 / 60))} min restantes)
                  </span>
                )}
              </>
            )}
          </div>
        </div>
        <div className="flex gap-2">
          {user?.role !== 'enseignant' && (
            <button
              className="flex items-center space-x-2 bg-primary-600 text-white px-4 py-2 rounded-lg hover:bg-primary-700"
              onClick={handleAdd}
            >
              <FiPlus />
              <span>Nouvelle ouverture</span>
            </button>
          )}
          {user?.role !== 'enseignant' && (
            <button
              className="flex items-center space-x-2 bg-green-600 text-white px-4 py-2 rounded-lg hover:bg-green-700"
              onClick={() => setShowBulkModal(true)}
            >
              <span>Ouvrir toutes les classes</span>
            </button>
          )}
          <button
            className="flex items-center space-x-2 bg-gray-600 text-white px-4 py-2 rounded-lg hover:bg-gray-700"
            onClick={() => {
              invalidateCache();
              loadDataWithCache();
              Swal.fire({
                icon: 'success',
                title: 'Cache rafraîchi',
                text: 'Les données ont été rechargées depuis le serveur.',
                timer: 2000,
                showConfirmButton: false
              });
            }}
            title="Rafraîchir le cache des données"
          >
            <FiRotateCcw size={16} />
            <span>Rafraîchir</span>
          </button>
        </div>
      </div>
      <div className="bg-white dark:bg-gray-800 shadow rounded-lg overflow-hidden relative">
        {isLoading ? (
          <div className="flex flex-col items-center justify-center py-20 px-6">
            <div className="relative">
              <div className="w-16 h-16 border-4 border-primary-200 dark:border-primary-800 border-t-primary-600 dark:border-t-primary-400 rounded-full animate-spin"></div>
              <div className="absolute inset-0 flex items-center justify-center">
                <div className="w-8 h-8 border-2 border-primary-300 dark:border-primary-700 border-t-primary-500 dark:border-t-primary-500 rounded-full animate-spin" style={{ animationDirection: 'reverse', animationDuration: '0.8s' }}></div>
              </div>
            </div>
            <p className="mt-6 text-lg font-medium text-gray-700 dark:text-gray-300">Chargement des données...</p>
            <p className="mt-2 text-sm text-gray-500 dark:text-gray-400">Veuillez patienter</p>
          </div>
        ) : (
          <>
            <table className="min-w-full divide-y divide-gray-200 dark:divide-gray-700">
              <thead className="bg-gray-50 dark:bg-gray-700">
                <tr>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 dark:text-gray-300 uppercase">Année</th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 dark:text-gray-300 uppercase">Classe</th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 dark:text-gray-300 uppercase">Enseignement</th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 dark:text-gray-300 uppercase">Niveau</th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 dark:text-gray-300 uppercase">Date ouverture</th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 dark:text-gray-300 uppercase">Part éval.</th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 dark:text-gray-300 uppercase">Part compo.</th>
                  <th className="px-6 py-3 text-right text-xs font-medium text-gray-500 dark:text-gray-300 uppercase">Actions</th>
                </tr>
              </thead>
              <tbody className="bg-white dark:bg-gray-800 divide-y divide-gray-200 dark:divide-gray-700">
                {(() => {
                  // Convertir les IDs en nombres pour la comparaison
                  const ouverturesFiltered = selectedYear
                    ? ouvertures.filter(o => {
                        const ouvertureAnneeId = typeof o.annee_scolaire_id === 'string' 
                          ? parseInt(o.annee_scolaire_id, 10) 
                          : o.annee_scolaire_id;
                        const selectedYearId = typeof selectedYear.id === 'string'
                          ? parseInt(selectedYear.id, 10)
                          : selectedYear.id;
                        return ouvertureAnneeId === selectedYearId;
                      })
                    : ouvertures;
                  if (ouvertures.length > 0) {
                    console.log('🔍 Filtrage:', {
                      totalOuvertures: ouvertures.length,
                      selectedYear: selectedYear?.id,
                      selectedYearType: typeof selectedYear?.id,
                      filteredCount: ouverturesFiltered.length,
                      sampleAnneeIds: ouvertures.slice(0, 3).map(o => ({ id: o.annee_scolaire_id, type: typeof o.annee_scolaire_id }))
                    });
                  }
                  return ouverturesFiltered.length === 0 ? (
                    <tr>
                      <td colSpan="8" className="px-6 py-4 text-center text-gray-500 dark:text-gray-400">
                        {ouvertures.length === 0 
                          ? 'Aucune ouverture' 
                          : `Aucune ouverture pour l'année ${selectedYear?.annee_scolaire || selectedYear?.id || 'sélectionnée'}`}
                      </td>
                    </tr>
                  ) : (
                    ouverturesFiltered.map((item) => (
                  <tr key={item.ouverture_classe_id || item.id} className="hover:bg-gray-50 dark:hover:bg-gray-700/80 transition-colors duration-150">
                    <td className="px-6 py-4 dark:text-gray-200">{item.annee_scolaire?.annee_scolaire || item.annee_scolaire_id}</td>
                    <td className="px-6 py-4 dark:text-gray-200">
                      {item.classe_nom || item.classe?.classe || item.classe_id}
                      {item.effectif !== undefined && (
                        <span className="ml-2 px-2 py-1 text-xs font-medium rounded-full bg-blue-100 dark:bg-blue-900 text-blue-800 dark:text-blue-200">
                          ({item.effectif} élève{item.effectif > 1 ? 's' : ''})
                        </span>
                      )}
                    </td>
                    <td className="px-6 py-4 dark:text-gray-200">{item.enseignement_nom || item.classe?.enseignement?.enseignement || item.classe?.enseignement_id || ''}</td>
                    <td className="px-6 py-4 dark:text-gray-200">{item.niveau_nom || item.classe?.niveau?.niveau || item.classe?.niveau_id || ''}</td>
                    <td className="px-6 py-4 dark:text-gray-200">{
                      item.date_ouverture
                        ? (() => {
                            const [y, m, d] = item.date_ouverture.split('-');
                            return `${d}/${m}/${y}`;
                          })()
                        : ''
                    }</td>
                    <td className="px-6 py-4 dark:text-gray-200">{item.part_evaluation}</td>
                    <td className="px-6 py-4 dark:text-gray-200">{item.part_composition}</td>
                    <td className="px-6 py-4 text-right">
                      {!['enseignant', 'intendant'].includes(user?.role) && (
                        <button
                          className="p-2 text-blue-600 dark:text-blue-400 hover:text-blue-900 dark:hover:text-blue-300 hover:bg-blue-50 dark:hover:bg-blue-900/30 mr-2 rounded-full transition-colors"
                          onClick={() => handleShowList(item)}
                          title="Liste des élèves"
                        >
                          <FiUsers size={18} />
                        </button>
                      )}
                      {/* Bouton passage classe supérieure si pas la Terminale et année suivante existe */}
                      {!['enseignant', 'intendant'].includes(user?.role) && (() => {
                        // Utiliser ouverturesAll pour avoir toutes les ouvertures (pas seulement celles filtrées)
                        // Cela permet de calculer correctement le maxNumOrdre même si ouvertures est filtré
                        const ouverturesPourCalcul = (ouverturesAll && ouverturesAll.length > 0) ? ouverturesAll : ouvertures;
                        
                        // Extraire num_ordre de toutes les ouvertures pour trouver le maximum
                        const allNumOrdres = ouverturesPourCalcul
                          .map(o => o.num_ordre || o.classe?.num_ordre)
                          .filter(n => typeof n === 'number' && !isNaN(n));
                        
                        const maxNumOrdre = allNumOrdres.length > 0 ? Math.max(...allNumOrdres) : undefined;
                        const currentNumOrdre = item.num_ordre || item.classe?.num_ordre;

                        // Vérifier si l'année suivante existe
                        const anneeActuelle = item.annee_scolaire?.annee_scolaire;
                        let anneeSuivanteExiste = false;

                        if (anneeActuelle && annees && annees.length > 0) {
                          const parties = anneeActuelle.split('-');
                          if (parties.length === 2) {
                            const anneeDebut = parseInt(parties[0]);
                            const anneeFin = parseInt(parties[1]);
                            const anneeSuivanteStr = `${anneeDebut + 1}-${anneeFin + 1}`;
                            anneeSuivanteExiste = annees.some(a => a.annee_scolaire === anneeSuivanteStr);
                          }
                        }

                        // Afficher le bouton si :
                        // 1. La classe a un num_ordre valide
                        // 2. Il existe une classe avec un num_ordre supérieur (pas la Terminale)
                        // 3. L'année suivante existe
                        if (typeof currentNumOrdre === 'number' 
                          && maxNumOrdre !== undefined 
                          && currentNumOrdre < maxNumOrdre 
                          && anneeSuivanteExiste) {
                          return (
                            <button
                              className="p-2 text-green-800 dark:text-green-400 hover:text-green-900 dark:hover:text-green-300 hover:bg-green-50 dark:hover:bg-green-900/30 mr-2 rounded-full transition-colors"
                              title="Passage en classe supéieure / Redoublement"
                              onClick={async () => {
                                // charge élèves & classes de destination
                                setPromotionSourceOuverture(item);
                                setShowPromotionModal(true);
                                // charge élèves de la classe
                                const res = await api.get(`/inscriptions?ouverture_classe_id=${item.ouverture_classe_id || item.id}`);
                                setPromotionEleves(res.data.data || []);
                                setPromotionSelected([]);
                                // Récupérer le num_ordre de la classe source (même logique que pour l'affichage du bouton)
                                const num_ordre_src = item.num_ordre || item.classe?.num_ordre;
                                
                                // Trouver l'année suivante en se basant sur le nom de l'année
                                const anneeActuelle = item.annee_scolaire?.annee_scolaire; // ex: "2024-2025"
                                let anneeSuivanteId = null;
                                let anneeSuivanteStr = '';

                                if (anneeActuelle && annees && annees.length > 0) {
                                  // Extraire les années (ex: "2024-2025" -> [2024, 2025])
                                  const parties = anneeActuelle.split('-');
                                  if (parties.length === 2) {
                                    const anneeDebut = parseInt(parties[0]);
                                    const anneeFin = parseInt(parties[1]);
                                    anneeSuivanteStr = `${anneeDebut + 1}-${anneeFin + 1}`; // "2025-2026"

                                    // Trouver l'ID de l'année suivante
                                    const anneeSuivante = annees.find(a => a.annee_scolaire === anneeSuivanteStr);
                                    if (anneeSuivante) {
                                      anneeSuivanteId = anneeSuivante.id;
                                    }
                                  }
                                }

                                // Récupérer les classes de destination selon les règles :
                                // 1. Même niveau (année suivante, même num_ordre) pour redoublants (toutes les séries disponibles)
                                // 2. Niveau supérieur (année suivante, num_ordre + 1) pour passage normal (toutes les séries disponibles)
                                // Utiliser ouverturesAll (toutes les ouvertures) au lieu de ouvertures (filtrées par professeur)
                                const ouverturesPourFiltrage = (ouverturesAll && ouverturesAll.length > 0) ? ouverturesAll : ouvertures;
                                
                                console.log('🔍 Debug filtrage classes destination:', {
                                  num_ordre_src,
                                  anneeActuelle,
                                  anneeSuivanteStr,
                                  anneeSuivanteId,
                                  ouverturesAllCount: ouverturesAll?.length || 0,
                                  ouverturesCount: ouvertures?.length || 0,
                                  ouverturesPourFiltrageCount: ouverturesPourFiltrage?.length || 0,
                                  anneesCount: annees?.length || 0,
                                  anneesList: annees?.map(a => ({ id: a.id, annee: a.annee_scolaire }))
                                });
                                
                                const filteredClasses = ouverturesPourFiltrage.filter(o => {
                                  const anS = Number(o.annee_scolaire_id);
                                  const num_ordre_dest = o.num_ordre || o.classe?.num_ordre;

                                  // Vérifier que num_ordre_dest est valide
                                  if (typeof num_ordre_dest !== 'number' || isNaN(num_ordre_dest)) {
                                    return false;
                                  }

                                  // Condition 1 : Redoublement - même niveau mais année suivante (toutes les séries)
                                  const isRedoublement = (anneeSuivanteId && anS === Number(anneeSuivanteId) && num_ordre_dest === num_ordre_src);

                                  // Condition 2 : Passage supérieur - niveau +1 mais année suivante (toutes les séries)
                                  const isPassageSuperieur = (anneeSuivanteId && anS === Number(anneeSuivanteId) && num_ordre_dest === num_ordre_src + 1);

                                  return isRedoublement || isPassageSuperieur;
                                });

                                console.log('🔍 Classes filtrées:', {
                                  filteredCount: filteredClasses.length,
                                  filteredClasses: filteredClasses.map(o => ({
                                    id: o.ouverture_classe_id || o.id,
                                    classe: o.classe?.classe || o.classe_nom,
                                    annee_scolaire_id: o.annee_scolaire_id,
                                    num_ordre: o.num_ordre || o.classe?.num_ordre,
                                    annee_scolaire: o.annee_scolaire?.annee_scolaire,
                                    fullObject: o
                                  }))
                                });
                                
                                console.log('🔍 promotionTargetClasses après setState:', filteredClasses.length);

                                setPromotionTargetClasses(
                                  filteredClasses.sort((a, b) => {
                                    // Trier : d'abord les redoublants (même num_ordre), puis les passages supérieurs (num_ordre + 1)
                                    const aNumOrdre = a.num_ordre || a.classe?.num_ordre || 0;
                                    const bNumOrdre = b.num_ordre || b.classe?.num_ordre || 0;
                                    const aIsRedoublant = aNumOrdre === num_ordre_src;
                                    const bIsRedoublant = bNumOrdre === num_ordre_src;

                                    if (aIsRedoublant && !bIsRedoublant) return -1;
                                    if (!aIsRedoublant && bIsRedoublant) return 1;

                                    // Pour chaque groupe : trier par nom de classe
                                    return (a.classe?.classe || '').localeCompare(b.classe?.classe || '');
                                  })
                                );
                                setPromotionTargetOuverture(null);
                              }}
                            >
                              <MdArrowUpward size={18} />
                            </button>
                          );
                        }
                        return null;
                      })()}
                      {!['enseignant', 'secretaire', 'intendant'].includes(user?.role) && (
                        <button
                          className="p-2 text-purple-600 dark:text-purple-400 hover:text-purple-900 dark:hover:text-purple-300 hover:bg-purple-50 dark:hover:bg-purple-900/30 mr-2 rounded-full transition-colors"
                          onClick={async () => {
                            setMoyennesClasse(item);
                            // Récupérer élèves
                            const resEleves = await api.get(`/inscriptions?ouverture_classe_id=${item.ouverture_classe_id || item.id}`);
                            const eleves = resEleves.data.data || [];
                            // Récupérer matières
                            const resMat = await api.get('/classe-matieres');
                            const matieres = (resMat.data.data || []).filter(cm => String(cm.ouverture_classe_id) === String(item.ouverture_classe_id || item.id));
                            // Récupérer moyennes
                            const resMoy = await api.get(`/moyennes?ouverture_classe_id=${item.ouverture_classe_id || item.id}`);
                            const moyennes = resMoy.data.data || [];
                            
                            // Charger les dispenses pour tous les élèves
                            const dispensesByInscriptionTemp = {};
                            for (const el of eleves) {
                              try {
                                const inscriptionId = el.inscription_id || el.id;
                                if (inscriptionId) {
                                  const resDisp = await api.get(`/dispenses-matieres?inscription_id=${inscriptionId}`);
                                  const dispenses = resDisp.data?.data || [];
                                  if (dispenses.length > 0) {
                                    dispensesByInscriptionTemp[inscriptionId] = {};
                                    dispenses.forEach(disp => {
                                      if (disp.matiere_id) {
                                        const matiereId = String(disp.matiere_id);
                                        if (!dispensesByInscriptionTemp[inscriptionId][matiereId]) {
                                          dispensesByInscriptionTemp[inscriptionId][matiereId] = {
                                            annuelle: disp.periode_id === null || disp.periode_id === undefined,
                                            periodes: (disp.periode_id !== null && disp.periode_id !== undefined) ? [Number(disp.periode_id)] : []
                                          };
                                        } else {
                                          if (disp.periode_id === null || disp.periode_id === undefined) {
                                            dispensesByInscriptionTemp[inscriptionId][matiereId].annuelle = true;
                                          } else {
                                            const periodeIdNum = Number(disp.periode_id);
                                            if (!dispensesByInscriptionTemp[inscriptionId][matiereId].periodes.includes(periodeIdNum)) {
                                              dispensesByInscriptionTemp[inscriptionId][matiereId].periodes.push(periodeIdNum);
                                            }
                                          }
                                        }
                                      }
                                    });
                                  }
                                }
                              } catch (error) {
                                console.error(`Erreur lors du chargement des dispenses pour l'élève ${el.nom} ${el.prenom}:`, error);
                              }
                            }
                            
                            setMoyennesData({eleves, matieres, moyennes});
                            setDispensesByInscription(dispensesByInscriptionTemp);
                            setShowMoyennesModal(true);
                          }}
                          title="Afficher les moyennes"
                        >
                          <FiBarChart2 size={18} />
                        </button>
                      )}
                      {!['enseignant', 'intendant'].includes(user?.role) && (
                        <button
                          className="p-2 text-pink-600 dark:text-pink-400 hover:text-pink-900 dark:hover:text-pink-300 hover:bg-pink-50 dark:hover:bg-pink-900/30 mr-2 rounded-full transition-colors"
                          onClick={() => {
                            setSelectedBulletinClasse(item);
                            setShowBulletinModal(true);
                            setSelectedBulletinPeriode(null);
                          }}
                          title="Générer les bulletins PDF"
                        >
                          <FiFileText size={18} />
                        </button>
                      )}
                      <button
                      className="p-2 text-green-600 dark:text-green-400 hover:text-green-900 dark:hover:text-green-300 hover:bg-green-50 dark:hover:bg-green-900/30 mr-2 rounded-full transition-colors"
                      onClick={async () => {
                      setEvalEditing(null);
                        const ouvertureId = item.ouverture_classe_id || item.id;
                        setEvalDefaultOuvertureId(ouvertureId);

                        // Charger les matières filtrées pour cette classe
                        await loadMatieresForEvaluation(ouvertureId);

                      setShowEvalModal(true);
                      }}
                      title="Ajouter une évaluation"
                      >
                      <FiFileText size={18} />
                      </button>
                      {!['enseignant', 'secretaire', 'intendant'].includes(user?.role) && (
                        <button
                          className="p-2 text-indigo-600 dark:text-indigo-400 hover:text-indigo-900 dark:hover:text-indigo-300 hover:bg-indigo-50 dark:hover:bg-indigo-900/30 mr-2 rounded-full transition-colors"
                          onClick={() => {
                            setMatModalOuverture(item);
                            setShowMatModal(true);
                          }}
                          title="Lier matières"
                        >
                          <FiBookOpen size={18} />
                        </button>
                      )}
                      <button
                        className="p-2 text-yellow-600 dark:text-yellow-400 hover:text-yellow-900 dark:hover:text-yellow-300 hover:bg-yellow-50 dark:hover:bg-yellow-900/30 mr-2 rounded-full transition-colors"
                        onClick={async () => {
                          // Préparer le modal vide
                          const ouvertureId = item.ouverture_classe_id || item.id;
                          setManualMoyenneOuvertureId(ouvertureId);
                          setManualMoyenneEleves([]);
                          setManualMoyenneEntete({classe: '', matiere: '', annee: '', periode: ''});
                          setManualMoyenneMatiere('');
                          setManualMoyennePeriode('');
                          setManualMoyenneLoaded(false);
                          setShowManualMoyenneModal(true);
                        }}
                        title="Saisie manuelle des moyennes"
                      >
                        <FiEdit3 size={18} />
                      </button>
                      {user?.role !== 'enseignant' && (
                        <>
                          <button
                          className="p-2 text-primary-600 dark:text-primary-400 hover:text-primary-900 dark:hover:text-primary-300 hover:bg-primary-50 dark:hover:bg-primary-900/30 mr-2 rounded-full transition-colors"
                          onClick={() => handleEdit(item)}
                          title="Modifier"
                          >
                          <FiEdit size={18} />
                          </button>
                          <button
                          className="p-2 text-red-600 dark:text-red-400 hover:text-red-900 dark:hover:text-red-300 hover:bg-red-50 dark:hover:bg-red-900/30 rounded-full transition-colors"
                          onClick={() => handleDelete(item.id)}
                          title="Supprimer"
                          >
                          <FiTrash size={18} />
                          </button>
                        </>
                      )}
                    </td>
                  </tr>
                ))
              );
            })()}
              </tbody>
            </table>
          </>
        )}
      </div>
      {showModal && (
        <OuvertureClasseModal
          show={showModal}
          onClose={handleModalClose}
          editing={editing}
          classes={classes}
          annees={annees}
          enseignements={enseignements}
          niveaux={niveaux}
        />
      )}
      <BulkOuvertureModal
        show={showBulkModal}
        onClose={() => setShowBulkModal(false)}
        classes={classes}
      />
      {/* Modal liste des élèves */}
      <Modal
        isOpen={showListModal}
        onRequestClose={() => setShowListModal(false)}
        contentLabel="Liste des élèves"
        ariaHideApp={false}
        style={{
          overlay: {
            backgroundColor: 'rgba(0, 0, 0, 0.75)',
            zIndex: 1000
          },
          content: {
            maxWidth: '1200px',
            width: '100%',
            margin: 'auto',
            height: 'auto',
            maxHeight: '600px',
            padding: 0,
            borderRadius: 12,
            overflow: 'hidden',
            backgroundColor: document.documentElement.classList.contains('dark') ? '#1F2937' : '#fff',
            color: document.documentElement.classList.contains('dark') ? '#E5E7EB' : '#111827'
          }
        }}
      >
        <div className="flex justify-between items-center px-6 pt-4 pb-2 border-b dark:border-gray-700">
          <h2 className="text-lg font-semibold dark:text-gray-100">Liste des élèves de la classe {listClasse?.classe_nom || listClasse?.classe?.classe || listClasse?.classe_id}</h2>
          <button onClick={() => setShowListModal(false)} className="text-gray-500 dark:text-gray-400 hover:text-gray-800 dark:hover:text-gray-200 text-2xl font-bold">×</button>
        </div>
        <div className="mb-4 flex justify-end gap-2 px-6 pt-2">
          <button 
            onClick={handlePrint} 
            className="flex items-center gap-2 bg-primary-600 text-white px-4 py-2 rounded hover:bg-primary-700"
            title="Ouvrir dans une nouvelle fenêtre pour impression"
          >
            <FiFileText size={16} />
            Imprimer
          </button>
          <button 
            onClick={handleExportCSV} 
            className="flex items-center gap-2 bg-green-600 text-white px-4 py-2 rounded hover:bg-green-700"
            title="Télécharger au format CSV"
          >
            📊
            Exporter CSV
          </button>
          <button 
            onClick={handleExportExcel} 
            className="flex items-center gap-2 bg-emerald-600 text-white px-4 py-2 rounded hover:bg-emerald-700"
            title="Télécharger au format Excel"
          >
            📈
            Exporter Excel
          </button>
        </div>
        <div className="overflow-x-auto w-full max-w-[1200px] px-6 pb-6">
          <div className="max-h-[450px] overflow-y-auto">
            <table className="min-w-[800px] w-full border dark:border-gray-700 rounded-lg">
            <thead className="bg-blue-50 dark:bg-blue-900 sticky top-0 z-10">
              <tr>
                <th className="px-3 py-2 border-b dark:border-gray-700 text-xs font-semibold text-blue-900 dark:text-blue-200 text-center">#</th>
                <th className="px-3 py-2 border-b dark:border-gray-700 text-xs font-semibold text-blue-900 dark:text-blue-200">Nom</th>
                <th className="px-3 py-2 border-b dark:border-gray-700 text-xs font-semibold text-blue-900 dark:text-blue-200">Prénom</th>
                <th className="px-3 py-2 border-b dark:border-gray-700 text-xs font-semibold text-blue-900 dark:text-blue-200 text-center">Sexe</th>
                <th className="px-3 py-2 border-b dark:border-gray-700 text-xs font-semibold text-blue-900 dark:text-blue-200 text-center">Type de séjour</th>
                <th className="px-3 py-2 border-b dark:border-gray-700 text-xs font-semibold text-blue-900 dark:text-blue-200 text-center">Matricule</th>
                <th className="px-3 py-2 border-b dark:border-gray-700 text-xs font-semibold text-blue-900 dark:text-blue-200 text-center">Action</th>
              </tr>
            </thead>
            <tbody>
              {listEleves.length === 0 ? (
                <tr>
                  <td colSpan="7" className="text-center py-4 text-gray-500 dark:text-gray-400">Aucun élève</td>
                </tr>
              ) : (
                listEleves.map((insc, idx) => (
                  <tr key={insc.id} className={idx % 2 === 0 ? 'bg-white dark:bg-gray-800' : 'bg-blue-50 dark:bg-blue-900/30'}>
                    <td className="px-3 py-2 text-center dark:text-gray-200">{idx + 1}</td>
                    <td className="px-3 py-2 dark:text-gray-200">{insc.nom}</td>
                    <td className="px-3 py-2 dark:text-gray-200">{insc.prenom}</td>
                    <td className="px-3 py-2 text-center dark:text-gray-200">{insc.sexe}</td>
                    <td className="px-3 py-2 text-center">
                      <span className={`px-2 py-1 rounded text-xs font-medium ${
                        insc.type_sejour === 'interne' ? 'bg-blue-100 dark:bg-blue-900 text-blue-800 dark:text-blue-200' :
                        insc.type_sejour === 'demi-pensionnaire' ? 'bg-green-100 dark:bg-green-900 text-green-800 dark:text-green-200' :
                        'bg-gray-100 dark:bg-gray-700 text-gray-800 dark:text-gray-200'
                      }`}>
                        {insc.type_sejour || 'externe'}
                      </span>
                    </td>
                    <td className="px-3 py-2 text-center dark:text-gray-200">{insc.matricule}</td>
                    <td className="px-3 py-2 text-center">
                      <div className="flex gap-2 justify-center">
                        <button
                          onClick={() => {
                            setOpenedPeriodSelectorEleveId(
                              openedPeriodSelectorEleveId === insc.id ? null : insc.id
                            );
                          }}
                          className="px-2 py-1 rounded bg-primary-600 text-white text-xs hover:bg-primary-700"
                        >
                          Imprimer bulletin
                        </button>
                        <ConditionalButton
                          entity="inscriptions"
                          permission="delete"
                          onClick={() => handleDeleteInscription(insc.id, insc.nom, insc.prenom)}
                          className="px-2 py-1 rounded bg-red-600 text-white text-xs hover:bg-red-700"
                          title="Supprimer l'inscription"
                        >
                          <FiTrash size={14} />
                        </ConditionalButton>
                        <button
                          onClick={async () => {
                            try {
                              const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:8000/api/v1';
                              const token = localStorage.getItem('token');
                              
                              // Utiliser l'ID de l'ouverture de classe - vérifier d'abord ouverture_classe_id puis id
                              const ouvertureId = listClasse?.ouverture_classe_id || listClasse?.id;
                              const eleveId = insc.eleve_id || insc.id;
                              
                              console.log('Certificat - listClasse:', listClasse);
                              console.log('Certificat - ouvertureId:', ouvertureId);
                              console.log('Certificat - eleveId:', eleveId);
                              
                              if (!ouvertureId) {
                                console.error('ouvertureId manquant. listClasse:', listClasse);
                                Swal.fire({
                                  icon: 'error',
                                  title: 'Erreur',
                                  text: 'Impossible de déterminer l\'ouverture de classe. Veuillez réessayer.'
                                });
                                return;
                              }
                              
                              if (!eleveId) {
                                console.error('eleveId manquant. insc:', insc);
                                Swal.fire({
                                  icon: 'error',
                                  title: 'Erreur',
                                  text: 'Impossible de déterminer l\'élève.'
                                });
                                return;
                              }
                              
                              const url = `${API_URL}/reports/certificat-scolarite?ouverture_classe_id=${ouvertureId}&eleve_id=${eleveId}&token=${token}`;
                              console.log('Certificat - URL:', url);
                              window.open(url, '_blank');
                            } catch (error) {
                              console.error('Erreur lors de l\'ouverture du certificat:', error);
                              Swal.fire({
                                icon: 'error',
                                title: 'Erreur',
                                text: 'Impossible de générer le certificat de scolarité: ' + (error.message || 'Erreur inconnue')
                              });
                            }
                          }}
                          className="px-2 py-1 rounded bg-green-600 text-white text-xs hover:bg-green-700"
                          title="Imprimer le certificat de scolarité"
                        >
                          Certificat
                        </button>
                      </div>
                      {openedPeriodSelectorEleveId === insc.id && (
                        <div className="mt-2 flex flex-col items-center">
                          <select
                            className="border dark:border-gray-600 dark:bg-gray-700 dark:text-gray-200 rounded px-2 py-1 text-xs"
                            value={periodSelectedByEleveId[insc.id] || ''}
                            onChange={e => setPeriodSelectedByEleveId(prev => ({...prev, [insc.id]: e.target.value}))}
                          >
                            <option value="">Sélectionner la période</option>
                            {periodes.map(p => (
                              <option key={p.id} value={p.id}>{p.libelle || p.periode}</option>
                            ))}
                          </select>
                          <button
                            className="mt-2 px-2 py-1 rounded bg-green-600 text-white text-xs hover:bg-green-700 flex items-center gap-1"
                            disabled={!periodSelectedByEleveId[insc.id] || loadingEleveBulletinId === insc.id}
                            onClick={async () => {
                              if (!periodSelectedByEleveId[insc.id]) return;
                              setLoadingEleveBulletinId(insc.id);
                              try {
                                const ouvertureId = listClasse.ouverture_classe_id || listClasse.id;
                                const periodeId = periodSelectedByEleveId[insc.id];
                                const url = `/bulletins/pdf?ouverture_classe_id=${ouvertureId}&periode_id=${periodeId}&eleve_id=${insc.eleve_id || insc.id}`;
                                const classeNom = (listClasse?.classe_nom || listClasse?.classe?.classe || listClasse?.classe_id || '').replace(/\s+/g, '_');
                                const anneeNom = (listClasse?.annee_scolaire?.annee_scolaire || listClasse?.annee_scolaire_id || '').replace(/\s+/g, '_');
                                const nomEleve = (insc.nom + '_' + insc.prenom).replace(/\s+/g, '_');
                                const periodeObj = periodes.find(p => String(p.id) === String(periodeId));
                                const periodeNom = ((periodeObj?.abrev || periodeObj?.periode || '')).replace(/\s+/g, '_');
                                const fileName = `Bulletin_${nomEleve}_${classeNom}_${anneeNom}_${periodeNom}.pdf`.replace(/\s+/g, '_');
                                const res = await api.get(url, { responseType: 'blob' });
                                const blob = new Blob([res.data], { type: 'application/pdf' });
                                const link = document.createElement('a');
                                link.href = window.URL.createObjectURL(blob);
                                link.download = fileName;
                                link.click();
                                setOpenedPeriodSelectorEleveId(null);
                                setPeriodSelectedByEleveId(prev => ({ ...prev, [insc.id]: '' }));
                                setLoadingEleveBulletinId(null);
                                Swal.fire({
                                  icon: 'success',
                                  title: 'PDF généré',
                                  text: `Le fichier ${fileName} a bien été généré.`,
                                  timer: 2500,
                                  showConfirmButton: false
                                });
                              } catch (err) {
                                setLoadingEleveBulletinId(null);
                                Swal.fire({
                                  icon: 'error',
                                  title: 'Erreur de génération',
                                  text: 'La génération du bulletin a échoué.',
                                });
                              }
                            }}
                          >
                            {loadingEleveBulletinId === insc.id ? (
                              <svg className="animate-spin h-4 w-4 text-white mr-1" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" /><path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v4a4 4 0 00-4 4H4z" /></svg>
                            ) : (
                              <FiFileText size={14}/>) }
                            Générer
                          </button>
                        </div>
                      )}
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
          </div>
        </div>
      </Modal>
    {showEvalModal && (
        <>
          <EvaluationModal
            isOpen={showEvalModal}
            onClose={() => {
              setShowEvalModal(false);
            }}
            onSaved={async (formData, editing) => {
              if (editing) {
                await api.put(`/evaluations/${editing.id}`, formData, {
                  headers: {
                    'Content-Type': 'multipart/form-data',
                  },
                });
              } else {
                await api.post('/evaluations', formData, {
                  headers: {
                    'Content-Type': 'multipart/form-data',
                  },
                });
              }
              setShowEvalModal(false);
            }}
            editing={evalEditing}
            ouvertures={ouverturesAll}
            matieres={evalMatieres}
            periodes={periodes}
            types={types}
            defaultOuvertureClasseId={evalDefaultOuvertureId}
          />
        </>
      )}
    {/* Modal de liaison matières (Ã  compléter avec drag and drop ou liste Ã  cocher) */}
      <Modal
        isOpen={showMatModal}
        onRequestClose={() => setShowMatModal(false)}
        contentLabel="Lier matières à la classe"
        ariaHideApp={false}
        style={{ 
          overlay: { backgroundColor: 'rgba(0,0,0,0.75)', zIndex: 1000 },
          content: { 
            maxWidth: '800px', 
            margin: 'auto', 
            borderRadius: 12, 
            padding: 0, 
            maxHeight: '700px', 
            overflowY: 'auto',
            backgroundColor: document.documentElement.classList.contains('dark') ? '#1F2937' : '#fff',
            color: document.documentElement.classList.contains('dark') ? '#E5E7EB' : '#111827'
          } 
        }}
      >
        <div className="p-6 dark:bg-gray-800">
            <h2 className="text-lg font-semibold mb-4 dark:text-gray-100">Lier matières à  {matModalOuverture?.classe_nom || matModalOuverture?.classe?.classe || matModalOuverture?.classe_id}</h2>
          {matModalLoading ? (
            <div className="text-center py-8 dark:text-gray-300">Chargement...</div>
          ) : (
            <DragDropContext onDragEnd={onMatModalDragEnd}>
              <div className="flex gap-6">
                <Droppable droppableId="matieres-disponibles">
                  {(provided) => (
                    <div ref={provided.innerRef} {...provided.droppableProps} className="w-96 min-w-[350px] bg-gray-50 dark:bg-gray-700 rounded-lg p-3 shadow">
                      <h3 className="font-bold mb-2 text-center dark:text-gray-200">Matières disponibles</h3>
                      {matieresDisponibles.map((m, idx) => (
                        <Draggable key={m.id} draggableId={`matiere-${m.id}`} index={idx}>
                          {(prov) => (
                            <div
                              ref={prov.innerRef}
                              {...prov.draggableProps}
                              {...prov.dragHandleProps}
                              className="bg-white dark:bg-gray-800 rounded shadow p-2 mb-2 cursor-move text-center dark:text-gray-200"
                            >
                              <span className="truncate whitespace-nowrap overflow-x-auto block">{m.lib_matiere}</span>
                            </div>
                          )}
                        </Draggable>
                      ))}
                      {provided.placeholder}
                    </div>
                  )}
                </Droppable>
                <Droppable droppableId="matieres-liees">
                  {(provided) => (
                    <div ref={provided.innerRef} {...provided.droppableProps} className="w-96 min-w-[350px] bg-blue-50 dark:bg-blue-900 rounded-lg p-3 shadow">
                      <h3 className="font-bold mb-2 text-center dark:text-blue-200">Matières liées</h3>
                      {matieresLieesObjs.map((m, idx) => (
                        <Draggable key={m.id} draggableId={`matiere-${m.id}`} index={idx}>
                          {(prov) => (
                            <div
                              ref={prov.innerRef}
                              {...prov.draggableProps}
                              {...prov.dragHandleProps}
                              className="bg-white dark:bg-gray-800 rounded shadow p-2 mb-2 cursor-move text-center dark:text-gray-200"
                              onClick={() => {
                                const cm = matModalClasseMatieres.find(cm => cm.matiere_id === m.id);
                                if (cm) handleEditLiaison(cm);
                              }}
                            >
                              <span className="truncate whitespace-nowrap overflow-x-auto block">{m.lib_matiere}</span>
                            </div>
                          )}
                        </Draggable>
                      ))}
                      {provided.placeholder}
                    </div>
                  )}
                </Droppable>
              </div>
            </DragDropContext>
          )}
          <div className="flex justify-end mt-4">
            <button onClick={() => setShowMatModal(false)} className="px-4 py-2 rounded bg-gray-200 dark:bg-gray-700 dark:text-gray-200 hover:bg-gray-300 dark:hover:bg-gray-600">Fermer</button>
          </div>
        </div>
      </Modal>
    {/* Modal édition liaison matière-classe */}
      <Modal
        isOpen={showEditLiaisonModal}
        onRequestClose={() => setShowEditLiaisonModal(false)}
        contentLabel="Modifier la liaison"
        ariaHideApp={false}
        style={{
          overlay: { zIndex: 1100, backgroundColor: 'rgba(0,0,0,0.5)' },
          content: {
            maxWidth: '500px',
            borderRadius: 12,
            padding: 0,
            zIndex: 1101,
            top: '50%',
            left: '50%',
            right: 'auto',
            bottom: 'auto',
            transform: 'translate(-50%, -50%)',
            backgroundColor: document.documentElement.classList.contains('dark') ? '#1F2937' : '#fff',
            color: document.documentElement.classList.contains('dark') ? '#E5E7EB' : '#111827'
          }
        }}
      >
        <form
          onSubmit={async (e) => {
            e.preventDefault();
            
            // Validation : coefficient et ordre_bulletin ne doivent pas être null ni égaux à 0
            const coef = parseFloat(editLiaisonForm.coef);
            const ordreBulletin = parseInt(editLiaisonForm.ordre_bulletin);
            
            if (!coef || coef === 0 || isNaN(coef)) {
              await Swal.fire({
                icon: 'error',
                title: 'Erreur de validation',
                text: 'Le coefficient doit être renseigné et différent de 0.',
                confirmButtonText: 'OK'
              });
              return;
            }
            
            if (!ordreBulletin || ordreBulletin === 0 || isNaN(ordreBulletin)) {
              await Swal.fire({
                icon: 'error',
                title: 'Erreur de validation',
                text: 'L\'ordre bulletin doit être renseigné et différent de 0.',
                confirmButtonText: 'OK'
              });
              return;
            }
            
            await api.put(`/classe-matieres/${editingLiaison.id}`, {
              ...editingLiaison,
              ...editLiaisonForm,
              coef: editLiaisonForm.coef,
              ordre_bulletin: editLiaisonForm.ordre_bulletin,
              professeur_id: editLiaisonForm.professeur_id || null,
              groupe_id: editLiaisonForm.groupe_id || editingLiaison.matiere_id,
              calculated: editLiaisonForm.calculated,
            });
            setShowEditLiaisonModal(false);
            setEditingLiaison(null);
            // refresh la liste
            const res = await api.get('/classe-matieres');
            const allClasseMatieres = res.data.data || [];
            setClasseMatieres(allClasseMatieres); // Mettre à jour le state global
            setClasseMatieresRefreshKey(prev => prev + 1); // Forcer le re-render des composants qui utilisent classeMatieres
            setMatModalClasseMatieres(
              allClasseMatieres.filter(cm => cm.ouverture_classe_id === (matModalOuverture.ouverture_classe_id || matModalOuverture.id))
            );
          }}
          className="p-6 dark:bg-gray-800"
        >
          <h2 className="text-lg font-semibold mb-4 dark:text-gray-100">Modifier la liaison</h2>
          {editingLiaison && (
            <div className="mb-4">
              <label className="block text-sm font-medium mb-1 dark:text-gray-300">Matière</label>
              <div className="w-full border dark:border-gray-600 rounded px-3 py-2 bg-gray-100 dark:bg-gray-700 text-gray-700 dark:text-gray-200">
                {matieres.find(m => m.id === editingLiaison.matiere_id)?.lib_matiere || editingLiaison.matiere_id}
              </div>
            </div>
          )}
          <div className="mb-4">
            <label className="block text-sm font-medium mb-1 dark:text-gray-300">Coefficient</label>
            <input type="number" name="coef" value={editLiaisonForm.coef} onChange={e => setEditLiaisonForm({ ...editLiaisonForm, coef: e.target.value })} className="w-full border dark:border-gray-600 dark:bg-gray-700 dark:text-gray-200 rounded px-3 py-2 focus:outline-none focus:ring-2 focus:ring-primary-500 focus:border-primary-500" step="0.01" min="0" />
          </div>
          <div className="mb-4">
            <label className="block text-sm font-medium mb-1 dark:text-gray-300">Ordre bulletin</label>
            <input type="number" name="ordre_bulletin" value={editLiaisonForm.ordre_bulletin} onChange={e => setEditLiaisonForm({ ...editLiaisonForm, ordre_bulletin: e.target.value })} className="w-full border dark:border-gray-600 dark:bg-gray-700 dark:text-gray-200 rounded px-3 py-2 focus:outline-none focus:ring-2 focus:ring-primary-500 focus:border-primary-500" />
          </div>
          <div className="mb-4">
            <label className="block text-sm font-medium mb-1 dark:text-gray-300">Professeur</label>
            <select
              name="professeur_id"
              value={editLiaisonForm.professeur_id}
              onChange={e => setEditLiaisonForm({ ...editLiaisonForm, professeur_id: e.target.value })}
              className="w-full border dark:border-gray-600 dark:bg-gray-700 dark:text-gray-200 rounded px-3 py-2 focus:outline-none focus:ring-2 focus:ring-primary-500 focus:border-primary-500"
            >
              <option value="">-- Sélectionner --</option>
              {(() => {
                if (!editingLiaison || !editingLiaison.matiere_id) {
                  return null;
                }
                // Trouver la matière sélectionnée
                const matiereId = editingLiaison.matiere_id;
                // Trouver les qualifications pour cette matière
                const qualifIds = qualifications
                  .filter(q => q.matiere_id === matiereId || String(q.matiere_id) === String(matiereId))
                  .map(q => q.id);
                
                if (qualifIds.length === 0) {
                  console.warn(`Aucune qualification trouvée pour la matière ID: ${matiereId}`);
                  return <option value="" disabled>Aucun professeur qualifié pour cette matière</option>;
                }
                
                // Filtrer les professeurs qui ont une qualification dans cette matière via prof_qualif
                const profsQualifiesIds = profQualif
                  .filter(pq => qualifIds.includes(pq.qualification_id) || qualifIds.includes(String(pq.qualification_id)))
                  .map(pq => pq.professeur_id)
                  .filter((id, index, self) => self.indexOf(id) === index); // Dédupliquer
                
                if (profsQualifiesIds.length === 0) {
                  console.warn(`Aucun professeur trouvé avec qualification pour matière ID: ${matiereId}`);
                  return <option value="" disabled>Aucun professeur qualifié pour cette matière</option>;
                }
                
                // Afficher les professeurs uniques
                const profsQualifies = professeurs.filter(prof => 
                  profsQualifiesIds.includes(prof.id) || profsQualifiesIds.includes(String(prof.id))
                );
                
                if (profsQualifies.length === 0) {
                  console.warn(`Aucun professeur trouvé dans la liste pour les IDs: ${profsQualifiesIds.join(', ')}`);
                  return <option value="" disabled>Aucun professeur disponible</option>;
                }
                
                return profsQualifies.map(prof => (
                  <option key={prof.id} value={prof.id}>{prof.nom} {prof.prenom}</option>
                ));
              })()}
            </select>
          </div>
          <div className="mb-4">
            <label className="block text-sm font-medium mb-1 dark:text-gray-300">Regroupement par matière</label>
            <select
              name="groupe_id"
              value={editLiaisonForm.groupe_id}
              onChange={e => setEditLiaisonForm({ ...editLiaisonForm, groupe_id: e.target.value })}
              className="w-full border dark:border-gray-600 dark:bg-gray-700 dark:text-gray-200 rounded px-3 py-2 focus:outline-none focus:ring-2 focus:ring-primary-500 focus:border-primary-500"
            >
              <option value="">-- Par défaut ({editingLiaison?.matiere_id && matieres.find(m => m.id === editingLiaison.matiere_id)?.lib_matiere}) --</option>
              {matieres.map(m => (
                <option key={m.id} value={m.id}>{m.lib_matiere}</option>
              ))}
            </select>
          </div>
          <div className="mb-4 flex items-center">
            <input
              type="checkbox"
              id="calculated"
              checked={editLiaisonForm.calculated === 'Y'}
              onChange={e => setEditLiaisonForm({ ...editLiaisonForm, calculated: e.target.checked ? 'Y' : 'N' })}
              className="mr-2 rounded border-gray-300 dark:border-gray-600 text-primary-600 focus:ring-primary-500"
            />
            <label htmlFor="calculated" className="text-sm font-medium dark:text-gray-300">Pris en compte dans la moyenne</label>
          </div>
          <div className="flex justify-end gap-2">
            <button type="button" onClick={() => setShowEditLiaisonModal(false)} className="px-4 py-2 rounded bg-gray-200 dark:bg-gray-700 dark:text-gray-200 hover:bg-gray-300 dark:hover:bg-gray-600">Annuler</button>
            <button type="submit" className="px-4 py-2 rounded bg-primary-600 text-white hover:bg-primary-700">Enregistrer</button>
          </div>
        </form>
      </Modal>
    {/* Modal de saisie manuelle des moyennes (nouvelle version) */}
    <Modal
      isOpen={showManualMoyenneModal}
      onRequestClose={() => setShowManualMoyenneModal(false)}
      shouldCloseOnOverlayClick={false}
      contentLabel="Saisie manuelle des moyennes"
      ariaHideApp={false}
      style={{
          overlay: {
            backgroundColor: 'rgba(0,0,0,0.75)', // plus sombre
            zIndex: 1000
          },
          content: {
            maxWidth: '1000px',
            width: '100%',
            height: '600px',
            margin: 'auto',
            borderRadius: 12,
            padding: 0,
            top: '50%',
            left: '50%',
            right: 'auto',
            bottom: 'auto',
            transform: 'translate(-50%, -50%)',
            overflow: 'hidden',
            backgroundColor: document.documentElement.classList.contains('dark') ? '#1F2937' : '#fff',
            color: document.documentElement.classList.contains('dark') ? '#E5E7EB' : '#111827'
          }
        }}
      >
      <div className="h-full flex flex-col dark:bg-gray-800">
        {/* Entête sticky */}
        {manualMoyenneLoaded && (
          <div className="sticky top-0 z-30 bg-white dark:bg-gray-800 border-b dark:border-gray-700 flex items-center px-6 py-3 justify-between" style={{minHeight: 56}}>
            <div className="flex flex-wrap gap-4 items-center">
              <div className="dark:text-gray-200"><b>Classe :</b> {manualMoyenneEntete.classe}</div>
              <div className="dark:text-gray-200"><b>Matière :</b> {manualMoyenneEntete.matiere}</div>
              <div className="dark:text-gray-200"><b>Année :</b> {manualMoyenneEntete.annee}</div>
              <div className="dark:text-gray-200"><b>Période :</b> {manualMoyenneEntete.periode}</div>
            </div>
            <button
              type="button"
              onClick={() => setShowManualMoyenneModal(false)}
              className="ml-4 text-gray-400 dark:text-gray-500 hover:text-gray-700 dark:hover:text-gray-300 text-2xl font-bold focus:outline-none"
              title="Fermer"
              style={{height: 36, minWidth: 36, lineHeight: '36px', borderRadius: '50%'}}
            >×</button>
          </div>
        )}
        <div className="flex gap-4 px-6 pt-4 pb-2 bg-white dark:bg-gray-800 items-end">
          <div>
            <div className="pt-4 mb-3"><span className="inline-flex items-center rounded-md bg-blue-50 dark:bg-blue-900 px-2 py-1 text-2xl font-medium text-blue-700 dark:text-blue-200 inset-ring inset-ring-blue-700/10">Gestion manuelle des moyennes (Devoirs et Compo)</span></div>
            <div className="pb-4"><span className="inline-flex items-center rounded-md bg-yellow-50 dark:bg-yellow-900 px-2 py-1 text-sm font-medium text-yellow-700 dark:text-yellow-200 inset-ring inset-ring-Yellow-700/10">Sélectionnez la matière et la période pour charger les données</span></div>
            <label className="block text-sm font-medium mb-1 dark:text-gray-300">Matière</label>
            <select
              key={classeMatieresRefreshKey}
              className="border dark:border-gray-600 dark:bg-gray-700 dark:text-gray-200 rounded px-3 py-2 focus:outline-none focus:ring-2 focus:ring-primary-500 focus:border-primary-500"
              value={manualMoyenneMatiere}
              onChange={e => {
                setManualMoyenneMatiere(e.target.value);
                setManualMoyenneLoaded(false);
              }}  
              required
            >
              <option value="">-- Sélectionner --</option>
              {(() => {
                // Filtrer les matières liées à cette classe
                let filteredClasseMatieres = classeMatieres.filter(
                  cm => String(cm.ouverture_classe_id) === String(manualMoyenneOuvertureId)
                );

                // Pour les professeurs, filtrer aussi selon leur ID
                if (user?.role === 'enseignant' && user?.professeur_id) {
                  filteredClasseMatieres = filteredClasseMatieres.filter(
                    cm => String(cm.professeur_id) === String(user.professeur_id)
                  );
                }

                const matiereIds = filteredClasseMatieres.map(cm => cm.matiere_id);
                const filteredMatieres = matieres.filter(m => matiereIds.includes(m.id));
                return filteredMatieres.map(m => (
                  <option key={m.id} value={m.id}>{m.lib_matiere}</option>
                ));
              })()}
            </select>
          </div>
          <div>
            <label className="block text-sm font-medium mb-1 dark:text-gray-300">Période</label>
            <select
              className="border dark:border-gray-600 dark:bg-gray-700 dark:text-gray-200 rounded px-3 py-2 focus:outline-none focus:ring-2 focus:ring-primary-500 focus:border-primary-500"
              value={manualMoyennePeriode}
              onChange={e => {
                setManualMoyennePeriode(e.target.value);
                setManualMoyenneLoaded(false);
              }}
              required
            >
              <option value="">-- Sélectionner --</option>
              {periodes.map(p => (
                <option key={p.id} value={p.id}>{p.libelle || p.periode}</option>
              ))}
            </select>
          </div>
          {manualMoyenneMatiere && manualMoyennePeriode && (
            <button
              type="button"
              className={`px-4 py-2 rounded ${manualMoyenneLoaded ? 'bg-gray-300 dark:bg-gray-600 text-gray-500 dark:text-gray-400 cursor-not-allowed' : 'bg-primary-600 text-white hover:bg-primary-700'}`}
              disabled={manualMoyenneLoaded}
              onClick={async () => {
                try {
                  // Afficher un indicateur de chargement
                  setManualMoyenneLoaded(false);

                  const ouverture = ouvertures.find(o => (o.ouverture_classe_id || o.id) === manualMoyenneOuvertureId);
                  setManualMoyenneEntete({
                    classe: ouverture?.classe_nom || ouverture?.classe?.classe || ouverture?.classe_id || '',
                    matiere: matieres.find(m => String(m.id) === String(manualMoyenneMatiere))?.lib_matiere || '',
                    annee: ouverture?.annee_scolaire?.annee_scolaire || ouverture?.annee_scolaire_id || '',
                    periode: periodes.find(p => String(p.id) === String(manualMoyennePeriode))?.abrev || ''
                  });

                  // Optimisation : Charger les élèves et les moyennes en parallèle avec des filtres spécifiques
                  const [elevesRes, moyennesRes] = await Promise.all([
                    // Récupérer seulement les élèves inscrits (avec données minimales)
                    api.get(`/inscriptions?ouverture_classe_id=${manualMoyenneOuvertureId}&fields=id,eleve_id,nom,prenom,matricule,sexe`),
                    // Récupérer seulement les moyennes pour cette matière et période spécifiques
                    api.get(`/moyennes?ouverture_classe_id=${manualMoyenneOuvertureId}&matiere_id=${manualMoyenneMatiere}&periode_id=${manualMoyennePeriode}`)
                  ]);

                  const eleves = elevesRes.data.data || [];
                  const moyennesFiltrees = moyennesRes.data.data || [];

                  // Créer une map des moyennes pour un accès rapide O(1)
                  const moyennesMap = new Map();
                  moyennesFiltrees.forEach(m => {
                    const key = `${String(m.eleve_id)}-${String(m.matiere_id)}-${String(m.periode_id)}`;
                    moyennesMap.set(key, m);
                  });

                  // Construire la liste des élèves avec leurs moyennes
                  setManualMoyenneEleves(eleves.map(e => {
                    const eleveId = e.eleve_id || e.id;
                    const key = `${String(eleveId)}-${String(manualMoyenneMatiere)}-${String(manualMoyennePeriode)}`;
                    const moyenneExistante = moyennesMap.get(key);

                    return {
                      eleve_id: eleveId,
                      nom: e.nom,
                      prenom: e.prenom,
                      valeur: moyenneExistante
                        ? formatValeurForDisplay(moyenneExistante.valeur)
                        : '',
                      appreciation: moyenneExistante ? moyenneExistante.appreciation : '',
                      moyenne_id: moyenneExistante ? moyenneExistante.id : null,
                      initial_valeur: moyenneExistante ? formatValeurForDisplay(moyenneExistante.valeur) : '',
                      initial_appreciation: moyenneExistante ? moyenneExistante.appreciation : ''
                    };
                  }));

                  setManualMoyenneLoaded(true);
                } catch (error) {
                  console.error('Erreur lors du chargement des moyennes:', error);
                  // En cas d'erreur, essayer l'ancienne méthode comme fallback
                  const moyRes = await api.get(`/moyennes?ouverture_classe_id=${manualMoyenneOuvertureId}`);
                  const ouverture = ouvertures.find(o => (o.ouverture_classe_id || o.id) === manualMoyenneOuvertureId);
                  setManualMoyenneEntete({
                    classe: ouverture?.classe_nom || ouverture?.classe?.classe || ouverture?.classe_id || '',
                    matiere: matieres.find(m => String(m.id) === String(manualMoyenneMatiere))?.lib_matiere || '',
                    annee: ouverture?.annee_scolaire?.annee_scolaire || ouverture?.annee_scolaire_id || '',
                    periode: periodes.find(p => String(p.id) === String(manualMoyennePeriode))?.abrev || ''
                  });
                  const res = await api.get(`/inscriptions?ouverture_classe_id=${manualMoyenneOuvertureId}`);
                  const eleves = res.data.data || [];
                  setManualMoyenneEleves(eleves.map(e => {
                    const moyenneExistante = (moyRes.data.data || []).find(m =>
                      String(m.eleve_id) === String(e.eleve_id || e.id) &&
                      String(m.matiere_id) === String(manualMoyenneMatiere) &&
                      String(m.periode_id) === String(manualMoyennePeriode)
                    );
                    return {
                      eleve_id: e.eleve_id || e.id,
                      nom: e.nom,
                      prenom: e.prenom,
                      valeur: moyenneExistante
                        ? formatValeurForDisplay(moyenneExistante.valeur)
                        : '',
                      appreciation: moyenneExistante ? moyenneExistante.appreciation : '',
                      moyenne_id: moyenneExistante ? moyenneExistante.id : null,
                      initial_valeur: moyenneExistante ? formatValeurForDisplay(moyenneExistante.valeur) : '',
                      initial_appreciation: moyenneExistante ? moyenneExistante.appreciation : ''
                    };
                  }));
                  setManualMoyenneLoaded(true);
                }
              }}
            >
              Charger
            </button>
          )}
        </div>
        <form
          className="flex-1 flex flex-col min-h-0"
          onSubmit={async (e) => {
            e.preventDefault();
            // Envoi en batch
            const promises = manualMoyenneEleves
              .filter(el =>
                // Création si pas de moyenne_id et valeur non vide
                (!el.moyenne_id && el.valeur !== '') ||
                // Modification si valeur ou appreciation a changé
                (el.moyenne_id && (String(el.valeur) !== String(el.initial_valeur) || String(el.appreciation) !== String(el.initial_appreciation)))
              )
              .map(el => {
                // Normaliser la valeur : convertir la virgule en point pour le backend MySQL
                const valeurPourBackend = (typeof el.valeur === 'string')
                  ? el.valeur.replace(',', '.')
                  : (el.valeur !== undefined && el.valeur !== null
                      ? String(el.valeur).replace(',', '.')
                      : '');

                if (el.moyenne_id) {
                  // Modification (PUT)
                  return api.put(`/moyennes/${el.moyenne_id}`, {
                    eleve_id: el.eleve_id,
                    ouverture_classe_id: manualMoyenneOuvertureId,
                    matiere_id: manualMoyenneMatiere,
                    periode_id: manualMoyennePeriode,
                    valeur: valeurPourBackend,
                    appreciation: getAppreciation(valeurPourBackend),
                    mode_calcul: 'manuel',
                    user_id: user?.id
                  });
                } else {
                  // Création (POST)
                  return api.post('/moyennes', {
                    eleve_id: el.eleve_id,
                    ouverture_classe_id: manualMoyenneOuvertureId,
                    matiere_id: manualMoyenneMatiere,
                    periode_id: manualMoyennePeriode,
                    valeur: valeurPourBackend,
                    appreciation: getAppreciation(valeurPourBackend),
                    mode_calcul: 'manuel',
                    user_id: user?.id 
                  });
                }
              });
            await Promise.all(promises);
            Swal.fire({
              icon: 'success',
              title: 'Succès',
              text: 'Les moyennes ont bien été enregistrées.',
              timer: 2000,
              showConfirmButton: false
            });
            setShowManualMoyenneModal(false);
          }}
        >
          <div className="flex-1 overflow-y-auto px-6 py-4">
            <div className="bg-white dark:bg-gray-800 rounded-lg shadow-sm border border-gray-200 dark:border-gray-700 overflow-hidden">
              <table className="min-w-full divide-y divide-gray-200 dark:divide-gray-700">
                <thead className="bg-gray-50 dark:bg-gray-700 sticky top-0 z-20">
                  <tr>
                    <th className="px-6 py-3 text-left text-xs font-semibold text-gray-700 dark:text-gray-300 uppercase tracking-wider border-b border-gray-200 dark:border-gray-600">
                      Elève
                    </th>
                    <th className="px-6 py-3 text-left text-xs font-semibold text-gray-700 dark:text-gray-300 uppercase tracking-wider border-b border-gray-200 dark:border-gray-600">
                      Moyenne
                    </th>
                    <th className="px-6 py-3 text-left text-xs font-semibold text-gray-700 dark:text-gray-300 uppercase tracking-wider border-b border-gray-200 dark:border-gray-600">
                      Appréciation
                    </th>
                  </tr>
                </thead>
                <tbody className="bg-white dark:bg-gray-800 divide-y divide-gray-200 dark:divide-gray-700">
                  {manualMoyenneEleves.map((el, idx) => (
                    <tr key={el.eleve_id} className="hover:bg-gray-50 dark:hover:bg-gray-700/80 transition-colors duration-150">
                      <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900 dark:text-gray-200">
                        {el.nom} {el.prenom}
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap">
                        <input
                          type="text"
                          value={el.valeur}
                          ref={ref => manualInputsRefs.current[idx] = ref}
                          onChange={e => {
                            let valeur = e.target.value;
                            // Accepter virgule ou point, mais normaliser en virgule pour l'affichage
                            // Remplacer le point par une virgule pour l'affichage
                            valeur = valeur.replace('.', ',');
                            // Valider que c'est un nombre valide entre 0 et 20
                            // Utiliser une regex qui accepte virgule ou point
                            if (valeur === '' || valeur === ',' || /^\d*[,.]?\d*$/.test(valeur)) {
                              // Pour la validation, convertir temporairement en point
                              const valeurPourValidation = valeur.replace(',', '.');
                              const numValue = parseFloat(valeurPourValidation);
                              if (valeur === '' || (!isNaN(numValue) && numValue >= 0 && numValue <= 20)) {
                                setManualMoyenneEleves(prev =>
                                  prev.map((x, i) =>
                                    i === idx
                                      ? { ...x, valeur, appreciation: getAppreciation(valeurPourValidation) }
                                      : x
                                  )
                                );
                              }
                            }
                          }}
                          onBlur={e => {
                            let valeur = e.target.value;
                            // Remplacer le point par une virgule pour l'affichage
                            valeur = valeur.replace('.', ',');
                            
                            // Si la valeur n'est pas vide, normaliser le format
                            if (valeur && valeur.trim() !== '') {
                              // Convertir en point temporairement pour la validation et le calcul
                              const valeurPourCalcul = valeur.replace(',', '.');
                              const numValue = parseFloat(valeurPourCalcul);
                              
                              if (!isNaN(numValue) && numValue >= 0 && numValue <= 20) {
                                // Formater avec 2 décimales et remplacer le point par une virgule
                                const normalizedValue = numValue.toFixed(2).replace('.', ',');
                                setManualMoyenneEleves(prev =>
                                  prev.map((x, i) =>
                                    i === idx
                                      ? { ...x, valeur: normalizedValue, appreciation: getAppreciation(valeurPourCalcul) }
                                      : x
                                  )
                                );
                              } else {
                                // Si la valeur n'est pas valide mais contient un point, le remplacer quand même par une virgule
                                setManualMoyenneEleves(prev =>
                                  prev.map((x, i) =>
                                    i === idx
                                      ? { ...x, valeur: valeur }
                                      : x
                                  )
                                );
                              }
                            } else if (valeur === '') {
                              // Si vide, garder vide
                              setManualMoyenneEleves(prev =>
                                prev.map((x, i) =>
                                  i === idx
                                    ? { ...x, valeur: '' }
                                    : x
                                )
                              );
                            }
                          }}
                          placeholder="0,00"
                          className="w-24 border border-gray-300 dark:border-gray-600 rounded-md px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-primary-500 focus:border-primary-500 dark:bg-gray-700 dark:text-gray-200 disabled:bg-gray-100 dark:disabled:bg-gray-800 disabled:text-gray-400 dark:disabled:text-gray-500"
                          onKeyDown={e => {
                            if (e.key === 'Enter' || e.key === 'Tab') {
                              e.preventDefault();
                              const next = manualInputsRefs.current[idx + 1];
                              if (next) next.focus();
                            }
                          }}
                          required
                          disabled={!manualMoyenneLoaded}
                        />
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap">
                        <input
                          type="text"
                          value={getAppreciation(typeof el.valeur === 'string' ? el.valeur.replace(',', '.') : el.valeur)}
                          className="w-full border border-gray-300 dark:border-gray-600 rounded-md px-3 py-2 text-sm bg-gray-50 dark:bg-gray-900 text-gray-700 dark:text-gray-300 cursor-not-allowed"
                          readOnly
                          tabIndex={-1}
                        />
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
              <div className="flex justify-end gap-2 px-6 pb-4">
                <button
                  type="button"
                  onClick={() => setShowManualMoyenneModal(false)}
                  className="px-4 py-2 rounded bg-gray-200 dark:bg-gray-700 dark:text-gray-200 hover:bg-gray-300 dark:hover:bg-gray-600"
                >
                  Annuler
                </button>
                {manualMoyenneLoaded && (
                  <button
                    type="submit"
                    className="px-4 py-2 rounded bg-primary-600 text-white hover:bg-primary-700"
                  >
                    Enregistrer
                  </button>
                )}
              </div>
        </form>
      </div>
    </Modal>
    {/* Modal des moyennes */}
      <Modal
        isOpen={showMoyennesModal}
        onRequestClose={() => setShowMoyennesModal(false)}
        contentLabel="Moyennes de la classe"
        ariaHideApp={false}
        style={{
          overlay: {
            backgroundColor: 'rgba(0,0,0,0.75)', // plus sombre
            zIndex: 1000
          },
          content: {
            maxWidth: '1300px',
            width: '100%',
            margin: 'auto',
            height: 'auto',
            maxHeight: '80%',
            padding: 0,
            borderRadius: 12,
            overflow: 'auto',
            backgroundColor: document.documentElement.classList.contains('dark') ? '#1F2937' : '#fff',
            color: document.documentElement.classList.contains('dark') ? '#E5E7EB' : '#111827'
          }
        }}
      >
        <div className="flex justify-between items-center px-6 pt-4 pb-2 border-b dark:border-gray-700">
          <h2 className="text-2xl font-semibold dark:text-gray-100">Moyennes de la classe {moyennesClasse?.classe_nom || moyennesClasse?.classe?.classe || moyennesClasse?.classe_id}</h2>
          <button onClick={() => setShowMoyennesModal(false)} className="text-gray-500 dark:text-gray-400 hover:text-gray-800 dark:hover:text-gray-200 text-2xl font-bold">×</button>
        </div>
        <div className="text-end mr-8 p-2">
          <button
            onClick={() => setShowPrintMoyModal(true)}
            className="px-3 py-2 rounded bg-green-600 hover:bg-green-700 text-white text-sm ml-2"
          >
            Imprimer la feuille de notes
          </button>
        </div>
        <div className="overflow-x-auto w-full max-w-[1600px] px-6 pb-6">
          <div className="max-h-[800px] overflow-y-auto">
            <table className="min-w-[1200px] w-full border dark:border-gray-700 rounded-lg">
              <thead className="bg-purple-50 dark:bg-purple-900 sticky top-0 z-10">
                <tr>
                  <th className="px-3 py-2 border-b dark:border-gray-700 text-sm font-semibold text-purple-900 dark:text-purple-200 text-center" rowSpan={2}>Elève</th>
                  <th className="px-3 py-2 border-b dark:border-gray-700 text-sm font-semibold text-purple-900 dark:text-purple-200 text-center" rowSpan={2}>Période</th>
                  <th className="px-3 py-2 border-b dark:border-gray-700 text-sm font-semibold text-purple-900 dark:text-purple-200 text-center" rowSpan={2}>Moy. gle.</th>
                  {moyennesData.matieres.map((m, idx) => (
                    <th key={m.matiere_id} className="px-4 pt-2 pb-0 border-b dark:border-gray-700 text-xs font-semibold text-purple-900 dark:text-purple-200 text-center">
                      {m.matiere?.abbrev_matiere || m.abbrev_matiere || m.matiere?.lib_matiere || m.lib_matiere || m.matiere_id}
                    </th>
                  ))}
                </tr>
                <tr>
                  {moyennesData.matieres.map((m, idx) => (
                    <th key={m.matiere_id + '-coef'} className="px-4 pb-2 pt-0 border-b dark:border-gray-700 text-sm text-purple-700 dark:text-purple-300 text-center font-normal">
                      <span className="text-red-700 dark:text-red-400 text-sm">({m.coef ?? '-'})</span>
                    </th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {moyennesData.eleves.length === 0 ? (
                  <tr>
                    <td colSpan={2 + moyennesData.matieres.length} className="text-center py-4 text-gray-500 dark:text-gray-400">Aucun élève</td>
                  </tr>
                ) : (
                  moyennesData.eleves.flatMap((el, idx) =>
                    periodes.map((periode, pidx) => (
                      <tr key={`${el.eleve_id || el.id}-${periode.id}`} className={(idx + pidx) % 2 === 0 ? 'bg-white dark:bg-gray-800' : 'bg-purple-50 dark:bg-purple-900/30'}>
                        {pidx === 0 && (
                          <td className="px-3 py-2 font-bold align-middle text-purple-900 dark:text-purple-200" rowSpan={periodes.length} style={{verticalAlign: 'middle'}}>
                            {el.nom} {el.prenom}
                          </td>
                        )}
                        <td className="px-3 py-2 text-center text-sm text-purple-600 dark:text-purple-300 font-semibold">{ periode.abrev || periode.periode || periode.libelle }</td>
                       <td className="px-3 py-2 text-center font-bold text-blue-900 dark:text-blue-300">
                        {(() => {
                          const inscriptionId = el.inscription_id || el.id;
                          const dispensesEl = dispensesByInscription[inscriptionId] || {};
                          let somme = 0;
                          let totalCoef = 0;
                          moyennesData.matieres.forEach(m => {
                            const matiereId = String(m.matiere_id || m.matiere?.id || m.id);
                            // Vérifier si l'élève est dispensé de cette matière pour cette période
                            const dispenseInfo = dispensesEl[matiereId];
                            const pidNum = Number(periode.id);
                            const isDispensed = dispenseInfo && (
                              dispenseInfo.annuelle === true || 
                              (Array.isArray(dispenseInfo.periodes) && dispenseInfo.periodes.some(p => Number(p) === pidNum))
                            );
                            
                            // Exclure les matières dispensées du calcul
                            if (isDispensed) {
                              return;
                            }
                            
                            const coef = Number(m.coef) || 0;
                            const moyenne = moyennesData.moyennes.find(moy =>
                              String(moy.eleve_id) === String(el.eleve_id || el.id) &&
                              String(moy.matiere_id) === String(m.matiere_id) &&
                              String(moy.periode_id) === String(periode.id)
                            );
                            let valeur = null;
                            if (moyenne && moyenne.valeur !== null && moyenne.valeur !== undefined) {
                              if (typeof moyenne.valeur === 'string') {
                                valeur = Number(moyenne.valeur.replace(',', '.'));
                              } else {
                                valeur = Number(moyenne.valeur);
                              }
                            }
                            if (!isNaN(valeur) && coef > 0) {
                              somme += valeur * coef;
                              totalCoef += coef;
                            }
                          });
                          if (totalCoef > 0) {
                            const moyGle = somme / totalCoef;
                            return isFinite(moyGle) ? formatValeurForDisplay(moyGle.toFixed(2)) : '-';
                          }
                          return '-';
                        })()}
                      </td>
                        {moyennesData.matieres.map((m, jdx) => {
                          const inscriptionId = el.inscription_id || el.id;
                          const dispensesEl = dispensesByInscription[inscriptionId] || {};
                          const matiereId = String(m.matiere_id || m.matiere?.id || m.id);
                          // Vérifier si l'élève est dispensé de cette matière pour cette période
                          let dispenseInfo = dispensesEl[matiereId];
                          if (!dispenseInfo && m.matiere_id) {
                            dispenseInfo = dispensesEl[String(m.matiere_id)];
                          }
                          if (!dispenseInfo && m.id) {
                            dispenseInfo = dispensesEl[String(m.id)];
                          }
                          if (!dispenseInfo && m.matiere?.id) {
                            dispenseInfo = dispensesEl[String(m.matiere.id)];
                          }
                          
                          const pidNum = Number(periode.id);
                          const isDispensed = dispenseInfo && (
                            dispenseInfo.annuelle === true || 
                            (Array.isArray(dispenseInfo.periodes) && dispenseInfo.periodes.some(p => Number(p) === pidNum))
                          );
                          
                          const moyenne = moyennesData.moyennes.find(moy =>
                            String(moy.eleve_id) === String(el.eleve_id || el.id) &&
                            String(moy.matiere_id) === String(m.matiere_id) &&
                            String(moy.periode_id) === String(periode.id)
                          );
                          
                          return (
                            <td key={m.matiere_id} className="px-3 py-2 text-center font-semibold dark:text-gray-200">
                              {isDispensed ? (
                                <span className="font-bold text-red-600 dark:text-red-400">Disp.</span>
                              ) : (
                                moyenne ? formatValeurForDisplay(moyenne.valeur) : '-'
                              )}
                            </td>
                          );
                        })}
                      </tr>
                    ))
                  )
                )}
              </tbody>
            </table>
          </div>
        </div>
      </Modal>
    {/* Modal de sélection de la période pour le PDF des bulletins */}
      <Modal
        isOpen={showBulletinModal}
        onRequestClose={() => setShowBulletinModal(false)}
        shouldCloseOnOverlayClick={false}
        contentLabel="Sélection de la période"
        ariaHideApp={false}
        style={{
          overlay: {
            backgroundColor: 'rgba(0,0,0,0.75)', // plus sombre
            zIndex: 1000
          },
          content: {
            maxWidth: '400px',
            minHeight: '300px',
            width: '100%',
            margin: 'auto',
            borderRadius: 12,
            padding: 0,
            top: '50%',
            left: '50%',
            right: 'auto',
            bottom: 'auto',
            transform: 'translate(-50%, -50%)',
            backgroundColor: document.documentElement.classList.contains('dark') ? '#1F2937' : '#fff',
            color: document.documentElement.classList.contains('dark') ? '#E5E7EB' : '#111827'
          }
        }}
      >
        <div className="flex justify-between items-center px-6 pt-4 pb-2 border-b dark:border-gray-700">
          <h2 className="text-lg font-semibold dark:text-gray-100">Sélection de la période</h2>
          <button onClick={() => setShowBulletinModal(false)} className="text-gray-500 dark:text-gray-400 hover:text-gray-800 dark:hover:text-gray-200 text-2xl font-bold">×</button>
        </div>
        <form
          className="p-6 dark:bg-gray-800"
          onSubmit={async (e) => {
            e.preventDefault();
            if (!selectedBulletinPeriode || !selectedBulletinClasse) return;
            setLoadingBulletin(true);
            try {
              const ouvertureId = selectedBulletinClasse.ouverture_classe_id || selectedBulletinClasse.id;
              const periodeId = selectedBulletinPeriode.value;
              const url = `/bulletins/pdf?ouverture_classe_id=${ouvertureId}&periode_id=${periodeId}`;
              // Format du nom de fichier comme demandé
              const classeNom = (selectedBulletinClasse.classe_nom || selectedBulletinClasse.classe?.classe || selectedBulletinClasse.classe_id || '').replace(/\s+/g, '_');
              const anneeNom = (selectedBulletinClasse.annee_scolaire?.annee_scolaire || selectedBulletinClasse.annee_scolaire_id || '').replace(/\s+/g, '_');
              const fileName = `Bulletins_${classeNom}_${anneeNom}.pdf`;
              const res = await api.get(url, { responseType: 'blob' });
              const blob = new Blob([res.data], { type: 'application/pdf' });
              const link = document.createElement('a');
              link.href = window.URL.createObjectURL(blob);
              link.download = fileName;
              link.click();
              setShowBulletinModal(false);
              setLoadingBulletin(false);
              Swal.fire({
                icon: 'success',
                title: 'PDF généré',
                text: `Le fichier ${fileName} a bien été généré.`,
                timer: 4500,
                showConfirmButton: false
              });
            } catch (err) {
              setLoadingBulletin(false);
              Swal.fire({
                icon: 'error',
                title: 'Erreur de génération',
                text: 'La génération du bulletin a échoué.',
              });
            }
          }}
        >
          <div className="mb-6">
            <label className="block text-sm font-medium mb-2 dark:text-gray-300">Période</label>
            <Select
              options={periodes.map(p => ({ value: p.id, label: p.libelle || p.periode }))}
              value={selectedBulletinPeriode}
              onChange={setSelectedBulletinPeriode}
              placeholder="Sélectionner la période..."
              isSearchable
              styles={selectStyles}
            />
          </div>
          <div className="flex justify-end gap-2">
            <button type="button" onClick={() => setShowBulletinModal(false)} className="px-4 py-2 rounded bg-gray-200 dark:bg-gray-700 dark:text-gray-200 hover:bg-gray-300 dark:hover:bg-gray-600">Annuler</button>
            <button
              type="submit"
              className={
                "px-4 py-2 rounded flex items-center justify-center gap-2 " +
                (!selectedBulletinPeriode || loadingBulletin
                  ? "bg-gray-300 dark:bg-gray-600 text-gray-500 dark:text-gray-400 cursor-not-allowed border border-gray-300 dark:border-gray-600"
                  : "bg-primary-600 text-white hover:bg-primary-700")
              }
              disabled={!selectedBulletinPeriode || loadingBulletin}
            >
              {loadingBulletin ? (
                <svg className="animate-spin mr-2 h-5 w-5 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" /><path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v4a4 4 0 00-4 4H4z" /></svg>
              ) : null}
              Générer les bulletins
            </button>
          </div>
        </form>
      </Modal>

      <Modal
        isOpen={showPrintMoyModal}
        onRequestClose={() => setShowPrintMoyModal(false)}
        contentLabel="Sélection des périodes Ã  imprimer"
        ariaHideApp={false}
        style={{
          overlay: { backgroundColor: 'rgba(0,0,0,0.75)', zIndex: 1100 },
          content: { 
            maxWidth: '400px', 
            width: '100%', 
            margin: 'auto', 
            borderRadius: 14, 
            top: '32%', 
            left: '50%', 
            right: 'auto', 
            bottom: 'auto', 
            transform: 'translate(-50%, -30%)',
            backgroundColor: document.documentElement.classList.contains('dark') ? '#1F2937' : '#fff',
            color: document.documentElement.classList.contains('dark') ? '#E5E7EB' : '#111827'
          }
        }}
      >
        <div className="flex flex-col gap-3 dark:bg-gray-800 p-6">
          <h3 className="text-lg font-semibold mb-3 dark:text-gray-100">Périodes Ã  imprimer</h3>
          <div className="flex flex-col mb-4">
            {periodes.map(p => (
              <label key={p.id} className="flex items-center gap-2 mb-1 dark:text-gray-200">
                <input
                  type="checkbox"
                  checked={printMoySelectedPeriods.includes(p.id)}
                  onChange={e => {
                    if (e.target.checked) {
                      setPrintMoySelectedPeriods(prev => [...prev, p.id]);
                    } else {
                      setPrintMoySelectedPeriods(prev => prev.filter(x => x !== p.id));
                    }
                  }}
                  className="rounded border-gray-300 dark:border-gray-600 text-primary-600 focus:ring-primary-500"
                />
                <span>{p.libelle || p.periode}</span>
              </label>
            ))}
          </div>
          <div className="flex justify-end gap-2">
            <button className="px-4 py-2 rounded bg-gray-200 dark:bg-gray-700 dark:text-gray-200 hover:bg-gray-300 dark:hover:bg-gray-600" onClick={() => setShowPrintMoyModal(false)}>
              Annuler
            </button>
            <button
              className="px-4 py-2 rounded bg-primary-600 text-white hover:bg-primary-700 disabled:opacity-50"
              disabled={printMoySelectedPeriods.length === 0}
              onClick={async () => {
                if (!printMoySelectedPeriods.length) return;
                setShowPrintMoyModal(false);
                
                setTimeout(async () => {
                  // Charger les dispenses pour tous les élèves
                  const dispensesByInscription = {};
                  for (const el of moyennesData.eleves) {
                    try {
                      // Utiliser inscription_id si disponible, sinon id
                      const inscriptionId = el.inscription_id || el.id;
                      if (!inscriptionId) {
                        console.warn(`Pas d'inscription_id pour l'élève ${el.nom} ${el.prenom}`);
                        continue;
                      }
                      const resDisp = await api.get(`/dispenses-matieres?inscription_id=${inscriptionId}`);
                      const dispenses = resDisp.data?.data || [];
                      if (dispenses.length > 0) {
                        dispensesByInscription[inscriptionId] = {};
                        dispenses.forEach(disp => {
                          if (!disp.matiere_id) {
                            console.warn('Dispense sans matiere_id:', disp);
                            return;
                          }
                          const matiereId = String(disp.matiere_id);
                          if (!dispensesByInscription[inscriptionId][matiereId]) {
                            dispensesByInscription[inscriptionId][matiereId] = {
                              annuelle: disp.periode_id === null || disp.periode_id === undefined,
                              periodes: disp.periode_id !== null && disp.periode_id !== undefined ? [Number(disp.periode_id)] : []
                            };
                          } else {
                            if (disp.periode_id === null || disp.periode_id === undefined) {
                              dispensesByInscription[inscriptionId][matiereId].annuelle = true;
                            } else {
                              const periodeIdNum = Number(disp.periode_id);
                              if (!dispensesByInscription[inscriptionId][matiereId].periodes.includes(periodeIdNum)) {
                                dispensesByInscription[inscriptionId][matiereId].periodes.push(periodeIdNum);
                              }
                            }
                          }
                        });
                      }
                    } catch (error) {
                      console.error(`Erreur lors du chargement des dispenses pour l'élève ${el.nom} ${el.prenom}:`, error);
                      // Continuer même en cas d'erreur
                    }
                  }
                  
                  
                  const periodsToPrint = printMoySelectedPeriods;
                  const etabNom = etablissement?.denomination || 'L. P. COMPLEXE SCOLAIRE BON PASTEUR DE KOMSILGA';
                  const anneeScolaire = moyennesClasse?.annee_scolaire?.annee_scolaire || moyennesClasse?.annee_scolaire_id || '';
                  const userNom = user?.nom || '';
                  const userPrenom = user?.prenom || '';
                  const userRole = user?.role || '';
                  const userUsername = user?.username || '';
                  
                  let head = `
                  <title>Feuille de notes</title>
                  <style>
                  @media print { @page { size: landscape; } }
                  body{ font-family: Arial,sans-serif; font-size:12px;}
                  table { border-collapse: collapse; width: 100%; margin-bottom: 1em; }
                  th, td { border: 1px solid #333; padding: 4px 5px; text-align: center; font-size: 12px;}
                  th { background: #eee;}
                  .print-header-container { display: flex; align-items: center; justify-content: center; gap: 20px; margin-bottom: 12px; padding: 10px; width: 100%; }
                  .print-header-text { text-align: center; }
                  .print-header { font-size: 2em; font-weight: bold; margin-bottom: 8px; }
                  .print-header-info { font-size: 0.9em; color: #666; margin-top: 4px; }
                  .print-header2 { font-size: 1.3em; font-weight: bold; margin-bottom:12px; text-align: center; }
                  </style>
                  `;
                  let content = '';
                  content += `<div class='print-header-container'>`;
                  content += `<div class='print-header-text'>`;
                  content += `<div class='print-header'>${etabNom}</div>`;
                  content += `<div class='print-header-info'>${anneeScolaire} ${userRole ? userRole.charAt(0).toUpperCase() + userRole.slice(1) : ''} ${userNom || ''} ${userPrenom || ''} ${userUsername || ''}</div>`;
                  content += `</div>`;
                  content += `</div>`;
                  content += `<div class='print-header2'>Feuille de notes<br>Classe: ${(moyennesClasse?.classe_nom || moyennesClasse?.classe?.classe || moyennesClasse?.classe_id || '')} - Année: ${anneeScolaire}</div>`;
                  content += `<table><thead><tr>`;
                  content += `<th>Ã‰lève</th><th>Période</th><th>Moy. gle.</th>`;
                  moyennesData.matieres.forEach(m => {
                  content += `<th>${m.matiere?.abbrev_matiere || m.abbrev_matiere || m.matiere?.lib_matiere || m.lib_matiere || m.matiere_id}</th>`;
                  });
                  content += `</tr>`;
                  content += `<tr><th></th><th></th><th></th>`;
                  moyennesData.matieres.forEach(m => {
                  content += `<th>(${m.coef ?? '-'})</th>`;
                  });
                  content += `</tr></thead><tbody>`;
                  moyennesData.eleves.forEach(el => {
                  const periodsToPrintForEleve = periodsToPrint;
                  const inscriptionId = el.inscription_id || el.id;
                  const dispensesEl = dispensesByInscription[inscriptionId] || {};
                  
                  
                  periodsToPrintForEleve.forEach((pid, pidx) => {
                  const periodeObj = periodes.find(p=>String(p.id)===String(pid));
                  content += `<tr>`;
                  if(pidx === 0) {
                  content += `<td rowspan="${periodsToPrintForEleve.length}" style="text-align:left;">${el.nom || ''} ${el.prenom || ''}</td>`;
                  }
                  content += `<td>${periodeObj?.abrev||periodeObj?.periode||'-'}</td>`;
                      // Moyenne générale pondérée (en excluant les matières dispensées) :
                      let somme = 0, totalCoef = 0;
                      moyennesData.matieres.forEach(m => {
                        const matiereId = String(m.matiere_id);
                        // Vérifier si l'élève est dispensé de cette matière pour cette période
                        const dispenseInfo = dispensesEl[matiereId];
                        const pidNum = Number(pid);
                        const isDispensed = dispenseInfo && (
                          dispenseInfo.annuelle === true || 
                          (Array.isArray(dispenseInfo.periodes) && dispenseInfo.periodes.some(p => Number(p) === pidNum))
                        );
                        
                        // Exclure les matières dispensées du calcul
                        if (isDispensed) {
                          return;
                        }
                        
                        const coef = Number(m.coef) || 0;
                        const moyenne = moyennesData.moyennes.find(moy =>
                          String(moy.eleve_id) === String(el.eleve_id || el.id) &&
                          String(moy.matiere_id) === String(m.matiere_id) &&
                          String(moy.periode_id) === String(pid)
                        );
                        let valeur = null;
                        if (moyenne && moyenne.valeur !== null && moyenne.valeur !== undefined) {
                          if (typeof moyenne.valeur === 'string') {
                            valeur = Number(moyenne.valeur.replace(',', '.'));
                          } else {
                            valeur = Number(moyenne.valeur);
                          }
                        }
                        if (!isNaN(valeur) && coef > 0) {
                          somme += valeur * coef;
                          totalCoef += coef;
                        }
                      });
                      let moyGle = (totalCoef > 0) ? formatValeurForDisplay((somme / totalCoef).toFixed(2)) : '-';
                      content += `<td>${moyGle}</td>`;
                      moyennesData.matieres.forEach(m => {
                        // Récupérer l'ID de la matière - peut être dans différentes propriétés
                        const matiereId = String(m.matiere_id || m.matiere?.id || m.id);
                        // Vérifier si l'élève est dispensé de cette matière pour cette période
                        // Essayer plusieurs clés possibles
                        let dispenseInfo = dispensesEl[matiereId];
                        if (!dispenseInfo && m.matiere_id) {
                          dispenseInfo = dispensesEl[String(m.matiere_id)];
                        }
                        if (!dispenseInfo && m.id) {
                          dispenseInfo = dispensesEl[String(m.id)];
                        }
                        if (!dispenseInfo && m.matiere?.id) {
                          dispenseInfo = dispensesEl[String(m.matiere.id)];
                        }
                        
                        const pidNum = Number(pid);
                        const isDispensed = dispenseInfo && (
                          dispenseInfo.annuelle === true || 
                          (Array.isArray(dispenseInfo.periodes) && dispenseInfo.periodes.some(p => Number(p) === pidNum))
                        );
                        
                        // PRIORITÉ ABSOLUE : Si dispensé, afficher "Disp." même si une moyenne existe
                        // Vérifier d'abord si une moyenne existe pour cette matière/période/élève
                        const moyenne = moyennesData.moyennes.find(moy =>
                          String(moy.eleve_id) === String(el.eleve_id || el.id) &&
                          String(moy.matiere_id) === String(m.matiere_id || m.matiere?.id || m.id) &&
                          String(moy.periode_id) === String(pid)
                        );
                        
                        if (isDispensed) {
                          content += `<td style="font-weight:bold;color:#d32f2f;">Disp.</td>`;
                        } else {
                          // Afficher la moyenne seulement si elle existe et n'est pas null/undefined
                          if (moyenne && moyenne.valeur !== null && moyenne.valeur !== undefined && moyenne.valeur !== '') {
                            content += `<td>${formatValeurForDisplay(moyenne.valeur)}</td>`;
                          } else {
                            content += `<td>-</td>`;
                          }
                        }
                      });
                      content += `</tr>`;
                    });
                  });
                  content += `</tbody></table>`;
                  
                  let printWin = window.open('', '', 'width=1000,height=900');
                  printWin.document.write(head + content);
                  printWin.document.close();
                  printWin.focus();
                  setTimeout(()=>{ printWin.print(); printWin.close(); }, 350);
                }, 50);
              }}
            >
              Imprimer
            </button>
          </div>
        </div>
      </Modal>

    {/* Modal Promotion (passage classe supérieure) */}
    <Modal
      isOpen={showPromotionModal}
      onRequestClose={()=>setShowPromotionModal(false)}
      contentLabel="Passage en classe supérieure"
      ariaHideApp={false}
      style={{
        overlay: { backgroundColor: 'rgba(0,0,0,0.75)', zIndex: 1100 },
        content: {
          maxWidth: '950px',
          maxHeight: '560px',
          margin: 'auto',
          borderRadius: 14,
          padding: 0,
          overflow: 'hidden',
          backgroundColor: document.documentElement.classList.contains('dark') ? '#1F2937' : '#fff',
          color: document.documentElement.classList.contains('dark') ? '#E5E7EB' : '#111827'
        }
      }}
    >
      <div className="flex flex-col h-full dark:bg-gray-800">
        <div className="flex justify-between items-center px-6 pt-4 pb-2 border-b dark:border-gray-700">
          <h2 className="text-lg font-semibold dark:text-gray-100">Passage classe supérieure / Redoublement : {promotionSourceOuverture?.classe?.classe}</h2>
          <button onClick={()=>setShowPromotionModal(false)} className="text-gray-500 dark:text-gray-400 hover:text-gray-800 dark:hover:text-gray-200 text-2xl font-bold">×</button>
        </div>
        <div className="px-6 pt-4 pb-2">
          {promotionTargetClasses.length === 0 ? (
            <div className="bg-yellow-50 dark:bg-yellow-900 border border-yellow-200 dark:border-yellow-700 rounded-lg p-4 text-center">
              <div className="flex items-center justify-center gap-2 text-yellow-800 dark:text-yellow-200">
                <span className="text-xl">⚠️</span>
                <span className="font-medium">Aucune classe de destination disponible</span>
              </div>
              <p className="text-sm text-yellow-700 dark:text-yellow-300 mt-2">
                Les classes de l'année suivante ({(() => {
                  const anneeActuelle = promotionSourceOuverture?.annee_scolaire?.annee_scolaire;
                  if (anneeActuelle) {
                    const parties = anneeActuelle.split('-');
                    if (parties.length === 2) {
                      const anneeDebut = parseInt(parties[0]);
                      const anneeFin = parseInt(parties[1]);
                      return `${anneeDebut + 1}-${anneeFin + 1}`;
                    }
                  }
                  return 'année suivante';
                })()}) ne sont pas encore ouvertes ou configurées.
              </p>
            </div>
          ) : (
            <div className="flex items-center gap-3">
              <span className="dark:text-gray-200">Classe de destination (supérieure ou même classe pour redoublement) :</span>
          <div style={{ minWidth: 260 }}>
            <Select
              options={(() => {
                console.log('🔍 Select render - promotionTargetClasses:', promotionTargetClasses.length, promotionTargetClasses);
                const options = promotionTargetClasses.map(o => {
                  const sourceNumOrdre = promotionSourceOuverture?.num_ordre || promotionSourceOuverture?.classe?.num_ordre;
                  const destNumOrdre = o.num_ordre || o.classe?.num_ordre;
                  const isRedoublement = destNumOrdre === sourceNumOrdre;
                  const option = {
                    value: o.ouverture_classe_id || o.id,
                    label: `${o.classe?.classe || o.classe_nom || ''} (${o.annee_scolaire?.annee_scolaire || o.annee_scolaire_id || ''})`,
                    data: o,
                    isRedoublement: isRedoublement,
                    icon: isRedoublement ? '🔄' : '⬆️',
                    color: isRedoublement ? '#10b981' : '#3b82f6' // vert pour redoublement, bleu pour passage
                  };
                  console.log('🔍 Option créée:', option);
                  return option;
                });
                console.log('🔍 Options finales pour Select:', options.length, options);
                if (options.length === 0) {
                  console.warn('⚠️ Aucune option générée pour le Select !');
                }
                return options;
              })()}
              value={promotionTargetOuverture ? {
                value: promotionTargetOuverture.ouverture_classe_id || promotionTargetOuverture.id,
                label: `${promotionTargetOuverture.classe?.classe || promotionTargetOuverture.classe_nom || ''} (${promotionTargetOuverture.annee_scolaire?.annee_scolaire || promotionTargetOuverture.annee_scolaire_id || ''})`,
                isRedoublement: (promotionTargetOuverture.num_ordre || promotionTargetOuverture.classe?.num_ordre) === (promotionSourceOuverture?.num_ordre || promotionSourceOuverture?.classe?.num_ordre),
                icon: (promotionTargetOuverture.num_ordre || promotionTargetOuverture.classe?.num_ordre) === (promotionSourceOuverture?.num_ordre || promotionSourceOuverture?.classe?.num_ordre) ? '🔄' : '⬆️',
                color: (promotionTargetOuverture.num_ordre || promotionTargetOuverture.classe?.num_ordre) === (promotionSourceOuverture?.num_ordre || promotionSourceOuverture?.classe?.num_ordre) ? '#10b981' : '#3b82f6'
              } : null}
              onChange={opt => {
                console.log('🔍 onChange Select - option sélectionnée:', opt);
                setPromotionTargetOuverture(
                  promotionTargetClasses.find(o => (o.ouverture_classe_id || o.id) === opt.value)
                );
              }}
              placeholder="Sélectionner la classe de destination..."
              isSearchable
              styles={{
                ...selectStyles,
                menuPortal: (base) => ({
                  ...base,
                  zIndex: 9999
                }),
                menu: (base) => ({
                  ...base,
                  zIndex: 9999,
                  position: 'absolute'
                })
              }}
              menuPortalTarget={document.body}
              menuPosition="fixed"
              formatOptionLabel={(option, { context, isSelected, isFocused }) => {
                console.log('🔍 formatOptionLabel appelé pour:', option);
                return (
                  <div className="flex items-center gap-2" style={{
                    color: option.color || '#000',
                    fontWeight: isSelected || isFocused ? '600' : 'normal'
                  }}>
                    <span className="text-lg">{option.icon || ''}</span>
                    <span className="flex-1">{option.label || 'Sans label'}</span>
                    {option.isRedoublement && (
                      <span className="text-xs px-2 py-1 rounded-full font-medium bg-green-100 dark:bg-green-900 text-green-800 dark:text-green-200">
                        Redoublement
                      </span>
                    )}
                    {!option.isRedoublement && (
                      <span className="text-xs px-2 py-1 rounded-full font-medium bg-blue-100 dark:bg-blue-900 text-blue-800 dark:text-blue-200">
                        Passage
                      </span>
                    )}
                  </div>
                );
              }}
            />
          </div>
            </div>
          )}
        </div>
        <div className="overflow-x-auto w-full max-w-[900px] px-6 pb-4 pt-2">
          <div className="max-h-[350px] overflow-y-auto">
            <table className="min-w-[700px] w-full border dark:border-gray-700 rounded-lg">
              <thead className="bg-green-50 dark:bg-green-900 sticky top-0 z-10">
                <tr>
                  <th className="px-3 py-2 border-b dark:border-gray-700 text-xs font-semibold text-green-900 dark:text-green-200 text-center"><input type="checkbox" checked={promotionEleves.length>0 && promotionSelected.length===promotionEleves.length} onChange={e=>setPromotionSelected(e.target.checked?promotionEleves.map(el=>el.id):[])} className="rounded border-gray-300 dark:border-gray-600 text-primary-600 focus:ring-primary-500" /></th>
                  <th className="px-3 py-2 border-b dark:border-gray-700 text-xs font-semibold text-green-900 dark:text-green-200">Nom</th>
                  <th className="px-3 py-2 border-b dark:border-gray-700 text-xs font-semibold text-green-900 dark:text-green-200">Prénom</th>
                  <th className="px-3 py-2 border-b dark:border-gray-700 text-xs font-semibold text-green-900 dark:text-green-200 text-center">Sexe</th>
                  <th className="px-3 py-2 border-b dark:border-gray-700 text-xs font-semibold text-green-900 dark:text-green-200 text-center">Matricule</th>
                </tr>
              </thead>
              <tbody>
                {promotionEleves.length === 0 ? (
                  <tr><td colSpan="6" className="text-center py-4 text-gray-500 dark:text-gray-400">Aucun élève</td></tr>
                ) : (
                  promotionEleves.map((el, idx) => (
                    <tr key={el.id} className={idx % 2 === 0 ? 'bg-white dark:bg-gray-800' : 'bg-green-50 dark:bg-green-900/30'}>
                      <td className="px-3 py-2 text-center">
                        <input type="checkbox" checked={promotionSelected.includes(el.id)} onChange={e=>setPromotionSelected(prev=>e.target.checked?[...prev,el.id]:prev.filter(x=>x!==el.id))} className="rounded border-gray-300 dark:border-gray-600 text-primary-600 focus:ring-primary-500" />
                      </td>
                      <td className="px-3 py-2 dark:text-gray-200">{el.nom}</td>
                      <td className="px-3 py-2 dark:text-gray-200">{el.prenom}</td>
                      <td className="px-3 py-2 text-center dark:text-gray-200">{el.sexe}</td>
                      <td className="px-3 py-2 text-center dark:text-gray-200">{el.matricule}</td>
                    </tr>
                  ))
                )}
              </tbody>
            </table>
          </div>
        </div>
        <div className="flex justify-end gap-3 px-6 pb-4">
          <button className="px-4 py-2 rounded bg-gray-200 dark:bg-gray-700 dark:text-gray-200 hover:bg-gray-300 dark:hover:bg-gray-600" onClick={()=>setShowPromotionModal(false)}>Annuler</button>
          <button
            className={
              'px-4 py-2 rounded text-white '+
              (promotionSelected.length>0 && promotionTargetOuverture && !promotionLoading ? 'bg-green-600 hover:bg-green-700' : 'bg-gray-300 dark:bg-gray-600 text-gray-500 dark:text-gray-400 cursor-not-allowed')
            }
            disabled={!(promotionSelected.length>0 && promotionTargetOuverture) || promotionLoading}
            onClick={async ()=>{
              setPromotionLoading(true);
              try {
                await Promise.all(promotionSelected.map(eleveInscriptionId => {
                  // Déterminer si c'est un redoublant :
                  // - Redoublant = même niveau (num_ordre) dans l'année suivante
                  // - Passage normal = niveau supérieur (num_ordre + 1) dans l'année suivante
                  const sourceNumOrdre = promotionSourceOuverture?.num_ordre || promotionSourceOuverture?.classe?.num_ordre;
                  const destNumOrdre = promotionTargetOuverture?.num_ordre || promotionTargetOuverture?.classe?.num_ordre;
                  const isRedoublant = destNumOrdre === sourceNumOrdre;

                  const insc = promotionEleves.find(el => el.id === eleveInscriptionId) || {};
                  return api.post('/inscriptions', {
                    eleve_id: insc.eleve_id || insc.id,
                    ouverture_classe_id: promotionTargetOuverture.ouverture_classe_id || promotionTargetOuverture.id,
                    type_sejour: insc.type_sejour || 'externe',
                    validation: insc.validation || 1,
                    redoublant: isRedoublant ? 1 : 0
                  });
                }
                ));
                // Compter les redoublants (même niveau dans l'année suivante)
                const sourceNumOrdre = promotionSourceOuverture?.num_ordre || promotionSourceOuverture?.classe?.num_ordre;
                const destNumOrdre = promotionTargetOuverture?.num_ordre || promotionTargetOuverture?.classe?.num_ordre;
                const redoublantsCount = promotionSelected.filter(eleveInscriptionId => {
                  return destNumOrdre === sourceNumOrdre;
                }).length;

                const passesCount = promotionSelected.length - redoublantsCount;

                let title = 'Passage effectué !';
                let text = '';

                if (passesCount > 0 && redoublantsCount > 0) {
                  text = `${passesCount} élève(s) passé(s) en classe supérieure, ${redoublantsCount} redoublant(s)`;
                } else if (passesCount > 0) {
                  text = `${passesCount} élève(s) passé(s) en classe supérieure`;
                } else if (redoublantsCount > 0) {
                  text = `${redoublantsCount} redoublant(s) confirmé(s)`;
                  title = 'Redoublement confirmé !';
                }

                Swal.fire({
                  icon: 'success',
                  title: title,
                  text: text,
                  timer: 3000,
                  showConfirmButton: false
                });
                setShowPromotionModal(false);
                setPromotionLoading(false);
              } catch (err) {
                setPromotionLoading(false);
                Swal.fire({
                  icon: 'error',
                  title: 'Erreur',
                  text: 'Le passage en classe supérieure a échoué.'
                });
              }
            }}
          >
            {promotionLoading ? 'Traitement...' : 'Inscrire les élèves sélectionnés'}
          </button>
        </div>
      </div>
    </Modal>
    </div>
  );
};

export default OuverturesClassesPage;

